export default defineNuxtPlugin(() => ({
    legacy: false,
    locale: 'it',
    messages: {
        it: {
            scarica_resoconto_precompilato: 'Scarica resoconto precompilato',
            compila_resoconto: 'Compila resoconto',
            numero_tentativi_terminati:
                "Hai terminato il numero di tentativi disponibili per questo quiz. Contatta l'amministratore per maggiori informazioni.",
            reset_numero_tentativi: 'Reset numero tentativi',
            avvia_quiz: 'Avvia Quiz',
            segna_come_completato: 'Segna come completato',
            utenti_aggiornati: 'Utenti aggiornati!',
            un_utente_ha_effettuato_modifiche: 'Un utente ha effettuato delle modifiche',
            tabella_corsi: 'Tabella corsi',
            generazione_resoconto: 'Generazione resoconto',
            tutore_mancante: 'Tutore mancante',
            tutore: 'Tutore',
            referente: 'Referente',
            data_assunzione_mancante: 'Data assunzione mancante',
            data_assunzione: 'Data assunzione',
            max_10mb_per_file: ' (max 10MB per file)',
            allegati: 'Allegati',
            attestato_caricato_con_successo: 'Attestato caricato con successo!',
            livello: 'Livello',
            nome_mancante: 'Nome mancante',
            cognome_mancante: 'Cognome mancante',
            username_mancante: 'Username mancante',
            email_mancante: 'Email mancante',
            email_non_valida: 'Email non valida',
            password_mancante: 'Password mancante',
            telefono_mancante: 'Telefono mancante',
            codice_fiscale_mancante: 'Codice fiscale mancante',
            titolo_studio_mancante: 'Titolo di studio mancante',
            livello_specializzazione_mancante: 'Livello specializzazione mancante',
            categoria_specializzazione_mancante: 'Categoria specializzazione mancante',
            ente_mancante: 'Ente mancante',
            azienda_mancante: 'Azienda mancante',
            seleziona_azienda_per_apprendisti:
                "Seleziona un'azienda per visualizzare gli apprendisti",
            seleziona_apprendista_per_corsi:
                'Seleziona un apprendista per visualizzare i corsi e quiz',
            riepilogo: 'Riepilogo',
            filtri: 'Filtri',
            dispositivo_scollegato: 'Dispositivo scollegato con successo!',
            sei_stato_disconnesso_dispositivo: 'Sei stato disconnesso da questo dispositivo',
            sei_stato_disconnesso_dispositivo_messaggio:
                'Per motivi di sicurezza, se non sei stato tu, ti consigliamo di cambiare la password.',
            questo_dispositivo: 'Dispositivo corrente',
            login_controllo_sessione: 'Controllo sessione in corso...',
            autenticazione_2FA_non_disponibile: 'Autenticazione 2FA non abilitata',
            scollega: 'Scollega',
            attivo: 'Attivo',
            non_attivo: 'Non attivo',
            attivi: 'Attivi',
            non_attivi: 'Non attivi',
            ultimo_accesso: 'Ultimo accesso',
            ultima_attivita: 'Ultima attività',
            i_miei_dispositivi: 'I miei dispositivi',
            codice_fiscale_non_valido: 'Codice fiscale non valido',
            partita_iva_non_valida: 'Partita IVA non valida',
            email_non_valida: 'Email non valida',
            telefono_non_valido: 'Numero di telefono non valido',
            immagine_sfondo_aggiornata: 'Immagine di sfondo aggiornata con successo!',
            immagine_sfondo_rimossa: 'Immagine di sfondo rimossa con successo!',
            totale: 'Totale',
            corrette: 'Corrette',
            errate: 'Errate',
            presente_risposta_facoltativa: 'La domanda presenta la risposta facoltativa',
            numero_tentativi: 'Numero tentativi',
            categorie_specializzazione: 'Categorie specializzazione',
            menu_quiz: 'Quiz',
            nessuna_domanda: 'Nessuna domanda',
            seleziona_domanda_per_risposte: 'Seleziona una domanda per visualizzare le risposte',
            nessuna_risposta: 'Nessuna risposta',
            risposte: 'Risposte',
            prossima_vuota: 'Prossima vuota',
            facoltative: 'Facoltative',
            valide: 'Valide',
            domande: 'Domande',
            progresso: 'Progresso',
            navigazione_domande: 'Navigazione domande',
            vuote: 'Vuote',
            facoltativa: 'Facoltativa',
            inizio: 'Inizio',
            non_risposte: 'Non risposte',
            nessuna_domanda_filtrata: 'Nessuna domanda filtrata',
            domanda: 'Domanda',
            elimina_domanda: 'Elimina domanda',
            seleziona_una_domanda_per_visualizzare_le_risposte:
                'Seleziona una domanda per visualizzare le risposte',
            risposta_facoltativa: 'Risposta facoltativa',
            obbligatorio: 'Obbligatorio',
            tipologia: 'Tipologia',
            corso_padre: 'Corso padre',
            categoria_specializzazione: 'Categoria specializzazione',
            titolo_studio: 'Titolo di studio',
            reminder_corso_email: 'Promemoria corso (Email)',
            reminder_corso_push: 'Promemoria corso (Push)',
            upload_attestato_email: 'Upload attestato (Email)',
            upload_attestato_push: 'Upload attestato (Push)',
            conclusione_corso_email: 'Conclusione corso (Email)',
            conclusione_corso_push: 'Conclusione corso (Push)',
            assegnazione_corso_email: 'Assegnazione corso (Email)',
            assegnazione_corso_push: 'Assegnazione corso (Push)',
            stato_del_sistema: 'Stato del sistema',
            supporto_browser: 'Supporto browser',
            supportato: 'Supportato',
            non_supportato: 'Non supportato',
            permessi: 'Permessi',
            sottoscrizione: 'Sottoscrizione',
            attiva: 'Attiva',
            non_attiva: 'Non attiva',
            controlli_base: 'Controlli base',
            richiedi_permesso: 'Richiedi permesso notifiche',
            attiva_notifiche: 'Attiva notifiche',
            disattiva_notifiche: 'Disattiva notifiche',
            invia_test: 'Invia test',
            dettagli_sottoscrizione: 'Dettagli sottoscrizione',
            endpoint: 'Endpoint',
            user_agent: 'User Agent',
            vapid: 'VAPID Key',
            permesso_concesso: 'Permesso concesso',
            permesso_negato: 'Permesso negato',
            ora_puoi_attivare_le_notifiche: 'Ora puoi attivare le notifiche',
            impossibile_ottenere_il_permesso: 'Impossibile ottenere il permesso',
            errore_richiesta_permesso: 'Errore nella richiesta del permesso',
            notifiche_attivate: 'Notifiche attivate',
            sottoscrizione_avvenuta_con_successo: 'Sottoscrizione alle notifiche completata',
            impossibile_attivare_le_notifiche: 'Impossibile attivare le notifiche',
            notifiche_disattivate: 'Notifiche disattivate',
            sottoscrizione_rimossa_con_successo: 'Sottoscrizione rimossa con successo',
            impossibile_disattivare_le_notifiche: 'Impossibile disattivare le notifiche',
            notifica_inviata: 'Notifica inviata',
            test_inviato_con_successo: 'Controlla le notifiche del dispositivo',
            impossibile_inviare_la_notifica: 'Impossibile inviare la notifica di test',
            disabilita_2FA: 'Disabilita 2FA',
            '2FA_disabilitata': 'Autenticazione 2FA disabilitata con successo!',
            aggiungi_domanda: 'Aggiungi domanda',
            aggiungi_riga: 'Aggiungi riga',
            aggiungi_risposta: 'Aggiungi risposta',
            aggiungi_risposta_facoltativa:
                'Aggiungi risposta facoltativa (non verrà conteggiata nel punteggio)',
            anni_corso: 'Anni corso',
            cap: 'CAP',
            codice_fiscale: 'Codice fiscale',
            corsi_associati: 'Corsi associati',
            elimina_riga: 'Elimina riga',
            indirizzo: 'Indirizzo',
            localita: 'Località',
            nazione: 'Nazione',
            ore: 'Ore',
            partita_iva: 'Partita IVA',
            provincia: 'Provincia',
            regione: 'Regione',
            risposta_corretta: 'Risposta corretta',
            risposta_non_corretta: 'Risposta non corretta',
            titolo: 'Titolo',
            menu_enti: 'Enti',
            menu_aziende: 'Aziende',
            menu_corsi: 'Corsi',
            menu_corsi_anagrafiche: 'Resoconto',
            menu_corsi_pianificazione: 'Pianificazione',
            menu_corsi_resoconto_utenti: 'Resoconto utenti',
            colonne_da_visualizzare: 'Colonne da visualizzare',
            ancora_destra: 'Ancora a destra',
            riapri_dialog: 'Riapri dialog',
            seleziona_righe_prima: 'Seleziona le righe prima di procedere',
            colonna_bloccata: 'Colonna bloccata',
            dettagli: 'Dettagli',
            menu_categorie_specializzazione: 'Categorie specializzazione',
            menu_corsi_resoconto_apprendisti: 'Resoconto apprendisti',
            dashboard: 'Dashboard',
            enti: 'Enti',
            aziende: 'Aziende',
            scorciatoia_ctrl_r: 'Scorciatoia: Ctrl + R',
            corsi: 'Corsi',
            'super-amministratore': 'Super amministratore',
            amministratore: 'Amministratore',
            risorsa: 'Risorsa',
            menu_corsi: 'Corsi',
            cambia_colore_riga: 'Cambia colore di sfondo',
            transparente: 'Trasparente',
            foto_profilo: 'Foto profilo',
            foto: 'Foto',
            provider_email: 'Provider',
            utente_ha_aggiornato_profilo: 'Il seguente utente ha aggiornato il proprio profilo',
            conferma_eliminazione: 'Sicuro di voler eliminare i dati selezionati?',
            eliminazione_dati: 'Eliminazione dati',
            password_temporanea: 'Password temporanea',
            ente: 'Ente',
            azienda: 'Azienda',
            configurazione_tabella_salvata: 'Configurazione tabella salvata con successo!',
            errore_salvataggio_configurazione:
                'Errore durante il salvataggio della configurazione della tabella',
            aggiungi_preferito: 'Aggiungi ai preferiti',
            apri_popup_esterno: 'Apri in una nuova finestra',
            cambio_tema: 'Cambio tema in corso...',
            rimuovi_preferito: 'Rimuovi dai preferiti',

            a: 'a',
            a_tempo: 'Alle',
            ad_ore: 'Ad ore',
            admin: 'Admin',
            aggiorna: 'Aggiorna',
            aggiorna_grafico: 'Aggiorna grafico',
            aggiorna_tabella: 'Aggiorna la tabella',
            aggiornamento_eseguito: 'Aggiornamento eseguito con successo!',
            aggiungi: 'Aggiungi',
            aggiungi_note: 'Aggiungi note',
            allega_file: 'Allega un file...',
            amministratore: 'Gestore',
            amministratore_del_gruppo: 'Gestore del gruppo',
            anno: 'Anno',
            annulla: 'Annulla',
            annulla_modifica: 'Annulla modifica',
            applica: 'Applica',
            archivia: 'Archivia',
            archiviazione_eseguita: 'Archiviazione eseguita con successo!',
            archivio_elimina_selezionati: 'Elimina selezionati',
            autenticazione_2FA: 'Autenticazione 2FA',
            avvia_timer: 'Avvia timer',
            avviso_date_con_date_disabilitate:
                'In caso il range di date selezionato comprenda delle date disabilitate, il sistema andrà a generare tante associazioni quanti sono i range di date che vengono trovati.',
            azioni: 'Azioni',
            benvenuto_descrizione: 'Gestione Corsi e Quiz',
            benvenuto_titolo: 'Elisa Gazzera',
            benvenuto_utente: 'Benvenuto',
            blocca_timer_per_disconnetterti: 'Blocca il timer per disconnetterti',
            calcola_data_fine: 'Calcola data fine stimata',
            calendario: 'Calendario',
            cambia_immagine: 'Cambia immagine',
            cambia_password: 'Cambia password',
            cambia_tema: 'Cambia tema',
            cambio_lingua: 'CAMBIO LINGUA IN CORSO...',
            campo_obbligatorio: '(*) = Dato obbligatorio',
            campo_richiesto: 'Campo richiesto',
            carica_file: 'Seleziona o trascina uno o più file da caricare',
            caricamento_dati: 'Caricamento dei dati in corso...',
            categoria: 'Categoria',
            categorie: 'Categorie',
            categorie_utenti: 'Categorie utenti',
            cerca: 'Cerca...',
            cerca_gif: 'Cerca una GIF...',
            chiudi: 'Chiudi',
            clicca_per_aprire_messaggio_fissato: 'Clicca per aprire il messaggio fissato',
            clicca_per_rimuovere_messaggio_fissato: 'Clicca per rimuovere il messaggio fissato',
            cliente: 'Cliente',
            codice: 'Codice',
            codice_autenticazione: 'Codice di autenticazione',
            codice_inviato: 'Codice inviato! Controlla la tua email per continuare.',
            codice_obbligatorio: 'Il codice è obbligatorio!',
            codice_prodotto: 'Codice prodotto',
            codice_prodotto_breve: 'Cod. prod.',
            codice_recupera_password_verificato:
                "Codice verificato correttamente, procedi con l'inserimento della nuova password",
            codice_testo:
                'Inserisci il codice che ti è stato inviato tramite e-mail prima della scadenza del tempo',
            cognome: 'Cognome',
            cognome_utente: 'Cognome utente',
            collaboratori_esterni: 'Apprendisti esterne',
            colore: 'Colore',
            commessa: 'Commessa',
            commessa_aggiornata: 'Commessa aggiornata con successo!',
            commessa_duplicata: 'Commessa duplicata con successo!',
            commessa_eliminata: 'Commessa eliminata con successo!',
            commessa_ricevuta: 'Commessa ricevuta',
            commessa_risorsa_aggiornata: 'Commessa aggiornata con successo!',
            commesse_giornaliere: 'Commesse giornaliere',
            commesse_importate: 'Commesse importate con successo',
            completato: 'Completato',
            concludi: 'Concludi',
            conclusa: 'Conclusa',
            concluso: 'Concluso',
            conferma: 'Conferma',
            conferma_archivia: 'Sicuro di voler archiviare i dati selezionati?',
            conferma_creazione_lavoro:
                'Uno o più utenti hanno la data di fine lavoro successiva alla data stimata di fine della commessa.\n Vuoi continuare?',
            conferma_elimina:
                'Sicuro di voler eliminare i dati selezionati?\nQuesta operazione non sarà reversibile.',
            conferma_mandare_rapportino: 'Confermi di voler mandare il rapportino al cliente?',
            configurazione_orari_giorni: 'Configurazione orari giorni',
            copia_desc_beep: 'Copia descrizione rapportino',
            copia_descrizione_rapportino: 'Copia descrizione rapportino per Bee.p',
            copia_orario_per_giorni_seguenti: 'Copia per giorni successivi',
            costo_finale: 'Costo finale',
            crea: 'Crea',
            creatoIl: 'Creato il',
            creazione_eseguita: 'Creazione eseguita con successo!',
            da_pianificare: 'Da pianificare',
            da_tempo: 'Dalle',
            data: 'Data',
            data_fine: 'Data fine',
            data_fine_maggiore_data_inizio:
                'La data di fine deve essere maggiore della data di inizio',
            data_fine_stimata: 'Data fine stimata',
            data_inizio: 'Data inizio',
            data_intervento: 'Data intervento',
            data_nascita: 'Data di nascita',
            data_non_valida: 'La data selezionata non è valida',
            data_popover_mancante: 'Data finale mancante',
            data_ultimo_login: 'Ultimo login',
            date: 'Date',
            date_utente_non_disponibile: "Date in cui l'utente non è disponibile",
            dati_non_disponibili: 'Dati non disponibili',
            dati_personali: 'Dati personali',
            denominazione: 'Denominazione',
            descrizione: 'Descrizione',
            descrizione_fase: 'Descrizione fase',
            descrizione_prodotto: 'Descrizione prodotto',
            deseleziona_tutti: 'Deseleziona tutti',
            destinatario: 'Destinatario',
            dettagli_base: 'Dettagli base',
            dettagli_cliente: 'Dettagli cliente',
            dettagli_fase: 'Dettagli fase',
            dettagli_lavoro: 'Dettagli lavoro',
            dettagli_prodotto: 'Dettagli prodotto',
            dettagli_utente: 'Dettagli utente',
            di: 'di',
            dimensione_file_non_valida: 'Il file supera la dimensione massima consentita, 10MB',
            dimensione_massima_file: 'Il file supera la dimensione massima consentita, 5MB',
            dipendente_cliente: 'Dipendente cliente',
            disponibile: 'Disponibile',
            documento: 'Documento',
            duplica_commessa: 'Duplica commessa',
            durata: 'Durata',
            durata_attuale: 'Ore att.',
            durata_giornata_lavorativa: 'Durata giornata lavorativa',
            durata_prevista: 'Ore prev.',
            elementi: 'elementi',
            elimina: 'Elimina',
            elimina_commessa: 'Elimina commessa',
            eliminazione_eseguita: 'Eliminazione eseguita con successo!',
            email: 'Email',
            emailResetPassInviata: "Email per reset password inviata all'utente specificato.",
            email_cliente: 'Email cliente',
            email_invio_rapportino: 'Email invio rapportino',
            error_effettua_login: 'Effettua il login per continuare',
            error_sottotitolo_401:
                "Ci dispiace, ma non hai i permessi necessari per completare l'operazione.\nRiprova più tardi e se l'errore persiste, contatta il nostro team tecnico fornendo dettagli sull'operazione.\nGrazie per la tua comprensione e pazienza.",
            error_sottotitolo_404:
                "Ci scusiamo, ma la pagina che stai cercando non è disponibile o è stata spostata.\nVerifica l'URL e assicurati che sia corretto.\nSe il problema persiste, potrebbe essere dovuto a un link obsoleto o a una risorsa eliminata.",
            error_sottotitolo_generale:
                "Ci dispiace, si è verificato un errore imprevisto durante l'operazione.\nRiprova più tardi e se l'errore persiste, contatta il nostro team tecnico fornendo dettagli sull'operazione.\nGrazie per la tua comprensione e pazienza.",
            error_titolo_401: 'Non autorizzato',
            error_titolo_404: 'Pagina non trovata',
            error_titolo_generale: 'Errore riscontrato',
            error_torna_pagina_iniziale: 'Torna alla pagina iniziale',
            errore: 'Errore!',
            errore_copia: 'Errore durante la copia negli appunti!',
            errore_generazione_qr: 'Errore generazione QR!',
            esporta: 'Esporta',
            fase: 'Fase',
            favorite_page_pagina_aggiunta: 'Pagina aggiunta ai preferiti',
            favorite_page_pagina_rimossa: 'Pagina rimossa dai preferiti',
            ferma_timer: 'Ferma timer',
            file_caricato: 'File caricato',
            file_e_documenti: 'File e documenti',
            file_media: 'File / Media',
            file_non_supportato: 'File non supportato',
            file_troppo_grande: 'File troppo grande',
            fino_a: 'Fino a',
            fornitura: 'Fornitura',
            foto: 'Foto',
            genera_password: 'Genera password',
            genera_qr: 'Genera QR',
            gestione_orari: 'Gestione orari',
            grafico: 'Grafico',
            id: 'ID',
            immagine_gruppo: 'Immagine gruppo',
            immagine_profilo: 'Immagine profilo',
            immagine_profilo_aggiornata: 'Immagine profilo aggiornata con successo!',
            importa: 'Importa',
            in_corso: 'In corso',
            inattivita_descrizione_1: "È stata rilevata un'inattività prolungata.",
            inattivita_descrizione_2: 'Per motivi di sicurezza sei stato disconnesso.',
            inattivita_titolo: 'Inattività rilevata!',
            indirizzo_ip: 'Indirizzo IP',
            indirizzo_luogo_intervento: 'Indirizzo luogo intervento',
            info_aggiuntive: 'Informazioni aggiuntive',
            informazione: 'Informazione',
            informazioni_breve: 'Info',
            informazioni_generali: 'Informazioni generali',
            inserire_ore_lavorate_effettive: 'Inserire le ore lavorate effettive',
            inserire_ore_lavorate_minimo_0_5: 'Inserire le ore lavorate (minimo 0.5)',
            inserire_relazione_intervento: "Inserire la relazione dell'intervento",
            inserisci_mail_valida: 'Inserisci una mail valida',
            installa_pwa: 'Installa PWA',
            invia_credenziali: 'Invia credenziali tramite e-mail',
            invia_file: 'Invia file',
            invia_rapportino: 'Invia rapportino',
            inviata_amministrazione: "Inviata all'amministrazione",
            inviata_cliente: 'Inviata al cliente',
            km_percorsi: 'Km percorsi',
            legenda: 'Legenda',
            legenda_categorie_commesse: 'Legenda categorie commesse',
            legenda_tag: 'Legenda tag',
            lista: 'Lista',
            livello_specializzazione: 'Livello specializzazione',
            login_aggiorna_accedi: 'Aggiorna e accedi',
            login_attendi: 'Attendi...',
            login_attendi_riprova: 'Attendi per riprovare!',
            login_benvenuto: 'Benvenuto!',
            login_campi_obbligatori: 'Inserire sia username che password per continuare',
            login_campo_non_sicuro: 'Campo non sicuro!',
            login_codice_scaduto: 'Codice scaduto! riprova per continuare',
            login_conferma_password: 'Conferma password',
            login_controlla_mail: 'Controllare le email per continuare',
            login_effetta_accesso: "Effettua l'accesso",
            login_email_reset_pass_inviata:
                "Email per reset password inviata all'utente specificato.",
            login_livello_sicurezza_password: 'Livello di sicurezza password',
            login_password: 'Password',
            login_password_dimenticata: 'Password dimenticata?',
            login_password_non_uguali: 'Le password non corrispondono',
            login_reset_password: 'Resetta la password',
            login_submit_text: 'Accedi',
            login_suggerimenti_password: 'Suggerimenti password',
            login_suggerimenti_password_1:
                'La password deve contenere almeno una lettera minuscola',
            login_suggerimenti_password_2:
                'La password deve contenere almeno una lettera maiuscola',
            login_suggerimenti_password_3: 'La password deve contenere almeno un numero',
            login_suggerimenti_password_4:
                'La password deve contenere almeno uno carattere speciale',
            login_suggerimenti_password_5: 'La password deve contenere almeno 8 caratteri',
            login_timeout_codice: 'Codice di verifica scaduto',
            login_troppe_richieste: 'Hai effettuato troppe richieste!',
            login_usa_password: 'Usa la tua password',
            login_username: 'Username',
            login_username_reset_password:
                "Inserisci l'username per cui si vuole richiedere il reset password nel campo 'username'.",
            login_utente_non_trovato: "Impossibile trovare l'utente inserito!",
            logout_conferma_disconnessione: 'Conferma',
            logout_disconnessione: 'Disconnessione',
            logout_disconnetti: 'Disconnetti',
            logout_messaggio_disconnessione: 'Sicuro di voler effettuare la disconnessione?',
            luogo_intervento: 'Luogo intervento',
            media_caricati: 'Media caricati',
            membri: 'Membri',
            menu_gestori: 'Gestori',
            menu_gestori_tooltip: 'Anagrafiche - Gestori',
            menu_anagrafiche: 'Anagrafiche',
            menu_categorie_commesse: 'Categorie commesse',
            menu_categorie_commesse_tooltip: 'Anagrafiche - Categorie commesse',
            menu_categorie_utenti: 'Categorie apprendisti',
            menu_categorie_utenti_tooltip: 'Anagrafiche - Categorie apprendisti',
            menu_commesse: 'Commesse',
            menu_commesse_occupazione: 'Occupazione',
            menu_commesse_occupazione_tooltip: 'Commesse - Occupazione',
            menu_commesse_pianificazione: 'Pianificazione',
            menu_commesse_pianificazione_tooltip: 'Commesse - Pianificazione',
            menu_commesse_resoconto: 'Resoconto',
            menu_commesse_resoconto_apprendisti: 'Resoconto apprendisti',
            menu_commesse_resoconto_apprendisti_tooltip: 'Commesse - Resoconto apprendisti',
            menu_commesse_resoconto_tooltip: 'Commesse - Resoconto',
            menu_dashboard: 'Dashboard',
            menu_gruppi: 'Gruppi chat',
            menu_gruppi_tooltip: 'Anagrafiche - Gruppi chat',
            menu_impostazioni: 'Impostazioni',
            menu_log: 'Log',
            menu_log_messaggi: 'Log messaggi',
            menu_log_messaggi_tooltip: 'Log - Messaggi',
            menu_log_tecnici: 'Log tecnici',
            menu_log_tecnici_tooltip: 'Log - Tecnici',
            menu_occupazione: 'Occupazione',
            menu_priorita_commesse: 'Priorità commesse',
            menu_priorita_commesse_tooltip: 'Anagrafiche - Priorità commesse',
            menu_apprendisti: 'Apprendisti',
            menu_apprendisti_tooltip: 'Anagrafiche - Apprendisti',
            menu_tag_commesse: 'Tag commesse',
            menu_tag_commesse_tooltip: 'Anagrafiche - Tag commesse',
            menu_utilita: 'Utilità',
            menu_utilita_archivio: 'Archivio',
            menu_utilita_archivio_tooltip: 'Utilità - Archivio',
            menu_utilita_calendario_eventi: 'Calendario eventi',
            menu_utilita_calendario_eventi_tooltip: 'Utilità - Calendario eventi',
            menu_utilita_chat: 'Chat',
            menu_utilita_chat_tooltip: 'Utilità - Chat',
            mese: 'Mese',
            messaggi: 'Messaggi',
            messaggi_da_leggere: 'Messaggi da leggere',
            messaggio_fissato: 'Messaggio fissato',
            messaggi_per_giorno: 'Messaggi per giorno',
            messaggi_solo_gestori: 'Solo gli gestori del gruppo possono scrivere',
            messaggi_solo_gestori_breve: 'Solo gli gestori possono scrivere',
            messaggio: 'Messaggio',
            messaggio_completo: 'Messaggio completo',
            messaggio_conclusione_commessa: 'Segnalare la commessa come conclusa?',
            messaggio_conferma_eliminazione_lavoro: 'Eliminazione eseguita con successo',
            messaggio_conferma_eliminazione_selezionati: 'Dati eliminati con successo!',
            messaggio_conferma_ripristino_selezionati: 'Dati ripristinati con successo!',
            messaggio_duplicazione: 'Duplicare la commessa?',
            messaggio_eliminato: 'Messaggio eliminato',
            messaggio_eliminazione: 'Eliminare la commessa?',
            messaggio_eliminazione_lavoro: 'Sei sicuro di voler eliminare il seguente lavoro?',
            messaggio_eliminazione_selezionati: 'Sicuro di voler eliminare i dati selezionati?',
            messaggio_manda_rapportino: 'Rimanda il rapportino al cliente',
            messaggio_ripristina_selezionati: 'Sicuro di voler ripristinare i dati selezionati?',
            mezza_giornata: 'Mezza giornata',
            mittente: 'Mittente',
            modifica: 'Modifica',
            modifica_lavori: 'Modifica lavori',
            modificato: 'Modificato',
            mostra: '(mostra il messaggio completo)',
            mostra_dashboard_commesse: 'Mostra dashboard commesse',
            mostra_dettagli: 'Mostra dettagli',
            mostra_informazioni: 'Mostra informazioni aggiuntive',
            mostra_occupazione: 'Mostra occupazione',
            mostra_ore: 'Visualizza il monte ore',
            mostrando: 'Mostrando',
            n_fase: 'Numero fase',
            nessun_cliente_selezionato: 'Nessun cliente selezionato',
            nessun_dato_archiviato: 'Non è presente alcun dato contrassegnato come archiviato',
            nessun_dato_disponibile: 'Nessun dato disponibile',
            nessun_messaggio_da_leggere: 'Non hai nessun messaggio da leggere. Bravo!',
            nessun_parametro: 'Nessun parametro',
            nessuna_chat_selezionata: 'Nessuna chat selezionata',
            nessuna_email_cliente: 'Nessuna email presente per il cliente selezionato',
            no: 'No',
            no_concluso: 'Non concluso',
            no_messaggi_nuovi: 'Non sono stati inviati nuovi messaggi',
            nome: 'Nome',
            nome_utente: 'Nome utente',
            nominativo: 'Nominativo',
            nominativo_cliente: 'Nominativo cliente',
            nominativo_dipendente: 'Nominativo dipendente cliente',
            non_disponibile: 'Non disponibile',
            non_programmato: 'Non programmato',
            note: 'Note',
            note_amministrative: 'Note amministrative',
            note_amministrative_breve: 'Note ammin.',
            note_intervento: 'Note intervento',
            numero: 'Numero',
            numero_commessa: 'Nome commessa',
            numero_documento: 'N. documento',
            nuovo_messaggio: 'Hai ricevuto un nuovo messaggio',
            occupazione: 'Occupazione',
            offline: 'Offline',
            oggi: 'Oggi',
            online: 'Online',
            online_ora: 'Online ora',
            oppure: 'oppure',
            opzioni_disponibili: 'Opzioni disponibili',
            ora_fine: 'Ora fine',
            ora_fine_obbligatoria: 'Ora fine obbligatoria',
            ora_fine_turno: 'Ora fine turno',
            ora_inizio: 'Ora inizio',
            ora_inizio_obbligatoria: 'Ora inizio obbligatoria',
            ora_inizio_turno: 'Ora inizio turno',
            ore_effettive: 'Ore effettive',
            ore_lavorate: 'Ore lavorate',
            ore_lavorate_breve: 'ore lav.',
            ore_lavorate_breve_header: 'Ore lav.',
            ore_lavorate_effettive: 'Ore lavorate effettive',
            ore_lavorate_effettive_breve_header: 'Ore eff.',
            ore_previste: 'Ore previste',
            ore_programmate: 'Ore programmate',
            ore_toggle_popover_mancanti: 'Tempistiche mancanti',
            ore_viaggio: 'Ore viaggio',
            panoramica_sistema: 'Panoramica sistema',
            parametri: 'Parametri',
            parametri_prodotto: 'Parametri prodotto',
            password: 'Password',
            password_aggiornata: 'Password aggiornata con successo!',
            password_cambiata: 'Password cambiata con successo!',
            password_gia_usata:
                "La password è già stata utilizzata in precedenza! Inserirne un'altra per continuare.",
            percentuale_completamento: 'Progresso',
            personali: 'Personali',
            pianifica: 'Pianifica',
            pianificata: 'Pianificata',
            pianificato: 'Pianificato',
            pianificazione: 'Pianificazione',
            preferiti: 'Preferiti',
            priorita: 'Priorità',
            priorita_lavoro: 'Priorità lavoro',
            privacy_policy: `<h1>INFORMATIVA PER IL TRATTAMENTO DI DATI</h1>
                  <p>In questa pagina si descrivono le modalità di gestione del sito in riferimento al trattamento dei dati personali degli utenti che lo consultano, nonché modalità e finalità di trattamento dei dati personali.</p>
                  <p>Si tratta di un'informativa resa anche ai sensi dell'art.13-14 Reg.to UE 2016/679 a coloro che interagiscono con i servizi web accessibili per via telematica a partire dall'indirizzo.</p>
                  <p>L'informativa è resa solo per il sito in oggetto e non anche per altri siti Web eventualmente consultabili tramite i nostri links, di cui non è in alcun modo responsabile.</p>
                  <p>
                      Nella qualità di Titolare del trattamento dei Suoi dati personali, ai sensi e per gli effetti del Reg.to UE 2016/679 - GDPR, con la presente La informa che la citata normativa prevede la tutela degli interessati rispetto al
                      trattamento dei dati personali e che tale trattamento sarà improntato ai principi di correttezza, liceità, trasparenza e di tutela della Sua riservatezza e dei Suoi diritti.
                  </p>
                  <p>I Suoi dati personali verranno trattati in accordo alle disposizioni legislative della normativa sopra richiamata e degli obblighi di riservatezza ivi previsti.</p>
                  <h2>TIPI DI DATI TRATTATI</h2>
                  <h3>Dati di Navigazione</h3>
                  <p>
                      I sistemi informatici e le procedure software preposte al funzionamento di questo sito web acquisiscono, nel corso del loro normale esercizio, alcuni dati personali la cui trasmissione è implicita nell'uso dei protocolli di
                      comunicazione di Internet. Si tratta di informazioni che non sono raccolte per essere associate ad interessati identificati, ma che per loro stessa natura potrebbero, attraverso elaborazioni ed associazioni con dati detenuti da terzi,
                      permettere di
                              permettere di identificare gli utenti. In questa categoria di dati rientrano gli indirizzi IP o i nomi a dominio dei computer utilizzati dagli utenti che si connettono al sito, gli indirizzi in notazione URI (Uniform Resource
                              Identifier) delle apprendisti richieste, l'orario della richiesta, il metodo utilizzato nel sottoporre la richiesta al server, la dimensione del file ottenuto in risposta, il codice numerico indicante lo stato della risposta data dal
                              server (buon fine, errore, ecc.) ed altri parametri relativi al sistema operativo e all'ambiente informatico dell'utente. Questi dati sono utilizzati al solo fine di ricavare informazioni statistiche anonime sull'uso del sito e per
                              controllarne il corretto funzionamento e vengono cancellati immediatamente dopo l'elaborazione. I dati potrebbero essere utilizzati per l'accertamento di responsabilità in caso di ipotetici reati informatici ai danni del sito.
                          </p>
                          <h3>Dati forniti volontariamente dall'utente</h3>
                          <p>
                              L'invio facoltativo, esplicito e volontario di posta elettronica agli indirizzi indicati su questo sito, così come la compilazione dei form per l'invio di richieste specifiche comportano la successiva acquisizione dell'indirizzo del
                              mittente, necessario per rispondere alle richieste, nonché degli eventuali altri dati personali inseriti nella missiva o nel form.
                              <br />Specifiche informative di sintesi vengono riportate o visualizzate nelle pagine del sito predisposte per particolari servizi a richiesta.
                          </p>
                          <h2>CONSEGUENZE DEL RIFIUTO DI CONFERIMENTO DEI DATI</h2>
                          <p>
                              A parte quanto specificato per i dati di navigazione, l'utente è libero di fornire i dati personali riportati nei moduli di richiesta, di iscrizione a mailing list o comunque indicati in contatti per sollecitare l'invio di materiale
                              informativo, tecnico o commerciale o di altre comunicazioni. Il loro mancato conferimento può comportare l'impossibilità di ottenere quanto richiesto.
                          </p>
                          <h2>MODALITA'DEL TRATTAMENTO</h2>
                          <p>
                              I dati vengono trattati principalmente con strumenti elettronici e informatici e memorizzati sia su supporti informatici che su supporti cartacei che su ogni altro tipo di supporto idoneo, nel rispetto delle modalità di cui agli art.
                              6, 32 del GDPR e mediante l'adozione delle adeguate misure di sicurezza previste. per prevenire la perdita di dati, usi illeciti o non corretti ed accessi non autorizzati.
                          </p>
                          <p>
                              La informiamo che, per fornire un servizio completo il nostro portale potrebbe contenere link ad altri siti web, non gestiti da noi. Non siamo responsabili di errori, contenuti, cookies, pubblicazioni di contenuto morale illecito,
                              pubblicità, banner o files non conformi alle disposizioni normative vigenti e del rispetto della normativa Privacy da parte di siti da noi gestiti a cui si fa riferimento. Per migliorare il servizio offerto è gradita una immediata
                              segnalazione di malfunzionamenti, abusi o suggerimenti all'indirizzo di posta elettronica. I suoi dati saranno trattati unicamente da personale espressamente autorizzato dal Titolare.
                          </p>
                          <h2>FINALITA'DEL TRATTAMENTO</h2>
                          <p>
                              Il trattamento dei dati verrà effettuato per:
                              <br />- dare la possibilità di accedere alle sezioni pubbliche e/o riservate del sito; <br />- dare esecuzione all'attivazione e alla manutenzione di eventuali servizi sottoscritti on-line; <br />- eseguire gli obblighi previsti da
                              leggi o regolamenti; <br />- la tutela del Titolare in sede giudiziaria; <br />- inviare materiale informativo di natura commerciale o promozionale <br />- consentire il monitoraggio costante sull'efficacia del servizio proposto.
                          </p>
                          <h2>SOGGETTI A CUI POTRANNO ESSERE COMUNICATI I DATI PERSONALI</h2>
                          <p>
                              I dati personali relativi al trattamento in questione possono essere comunicati anche a soggetti a cui sia riconosciuta la facoltà di accedere ai Vostri dati personali da norme di legge o di normative secondarie e/o comunitarie.
                              Inoltre alcuni dati possono essere comunicati e diffusi agli operatori internet si avvale per la gestione dei propri domini. La diffusione dei dati raccolti non è prevista.
                          </p>
                          <h2>PERIODO DI CONSERVAZIONE DEI DATI</h2>
                          <p>
                              Le segnaliamo che, nel rispetto dei principi di liceità, limitazione delle finalità e minimizzazione dei dati, ai sensi dell'art. 5 del GDPR, il periodo di conservazione dei Suoi dati personali è pari ad anni 15. Alla scadenza del
                              suddetto periodo di conservazione, i dati personali verranno automaticamente cancellati.
                          </p>
                          <h2>DIRITTI DEGLI INTERESSATI</h2>
                          <p>Reg.to UE 2016/679: Art. 15, 16, 17, 18, 19, 20, 21, 22 - Diritti dell'Interessato</p>
                          <p>1. L'interessato ha diritto di ottenere la conferma dell'esistenza o meno di dati personali che lo riguardano, anche se non ancora registrati, e la loro comunicazione in forma intelligibile.</p>
                          <p>
                              2. L'interessato ha diritto di ottenere l'indicazione:
                              <br />a. dell'origine dei dati personali; <br />b. delle finalità e modalità del trattamento; <br />c. della logica applicata in caso di trattamento effettuato con l'ausilio di strumenti elettronici; <br />d. degli estremi
                              identificativi del titolare, dei responsabili e del rappresentante designato ai sensi dell'articolo 5, comma 2; <br />e. dei soggetti o delle categorie di soggetti ai quali i dati personali possono essere comunicati o che possono
                              venirne a conoscenza in qualità di rappresentante designato nel territorio dello Stato, di responsabili o incaricati.
                          </p>
                          <p>
                              3. L'interessato ha diritto di ottenere:
                              <br />a. l'aggiornamento, la rettificazione ovvero, quando vi ha interesse, l'integrazione dei dati; <br />b. la cancellazione, la trasformazione in forma anonima o il blocco dei dati trattati in violazione di legge, compresi quelli
                              di cui non è necessaria la conservazione in relazione agli scopi per i quali i dati sono stati raccolti o successivamente trattati; <br />c. l'attestazione che le operazioni di cui alle lettere a) e b) sono state portate a conoscenza,
                              anche per quanto riguarda il loro contenuto, di coloro ai quali i dati sono stati comunicati o diffusi, eccettuato il caso in cui tale adempimento si rivela impossibile o comporta un impiego di mezzi <br />d. manifestamente
                              sproporzionato rispetto al diritto tutelato; <br />e. la portabilità dei dati.
                          </p>
                          <p>
                              4. L'interessato ha diritto di opporsi, in tutto o in parte:
                              <br />a. per motivi legittimi al trattamento dei dati personali che lo riguardano, ancorché pertinenti allo scopo della raccolta; <br />b. al trattamento di dati personali che lo riguardano a fini di invio di materiale pubblicitario o
                              di vendita diretta o per il compimento di ricerche di <br />c. mercato o di comunicazione commerciale
                          </p>
                          <p>
                              L'utente ha diritto di ottenere dal titolare la cancellazione (diritto all'oblio), la limitazione, l'aggiornamento, la rettificazione, la portabilità, l'opposizione al trattamento dei dati personali che La riguardano, nonché in
                              generale può esercitare tutti i diritti previsti dagli art. 15, 16, 17, 18, 19, 20, 21, 22 del GDPR.
                          </p>
                          <p>Per esercitare i diritti sopra elencati, l'interessato dovrà rivolgere richiesta scritta attraverso e-mail.</p>
                          <p></p>
                          <h2>COOKIES</h2>
                          <p>
                              Per cookies s'intende un elemento testuale che viene inserito nel disco fisso di un computer o altro dispositivo dal fornitore del servizio on line ai visitatori del sito internet . I cookie possono raccogliere informazioni sulle
                              abitudini dei visitatori circa l'utilizzo del suddetto sito Internet, registrando le attività del loro computer o di altro dispositivo riguardo il suddetto sito, per esempio quando si tratta di fare degli acquisti.
                          </p>
                          <h3>I COOKIES possono essere:</h3>
                          <h3>Cookie proprietari (anche detti di prima parte)</h3>
                          <p>I cookie proprietari sono cookie che vengono salvati direttamente nel computer o altro dispositivo. Possono includere cookie come quelli di sessione e i cookie persistenti (descritti oltre).</p>
                          <p>I cookie proprietari possono essere utilizzati per seguire i movimenti effettuati dal computer o altro dispositivo del visitatore consultando il sito, per esempio per scopi di analisi.</p>
                          <h3>Cookie di terze parti</h3>
                          <p>Non vengono memorizzati cookie di terze parti</p>
                          <h3>Cookie di sessione</h3>
                          <p>
                              La durata che intercorre tra il momento in cui si apre il browser Internet e il momento in cui lo si chiude si chiama sessione di navigazione. I cookie di sessione sono cookie memorizzati nel computer o altro dispositivo del
                              visitatore nel corso di una sessione di navigazione, ma che scadono e sono normalmente eliminati alla fine di una sessione di navigazione.
                          </p>
                          <h3>Cookie persistenti</h3>
                          <p>
                              I cookie persistenti sono cookie memorizzati nel computer o altro dispositivo del visitatore nel corso di una sessione di navigazione, ma che restano nel computer o altro dispositivo dopo la fine della suddetta sessione di navigazione
                              (es registrazione della password). I cookie persistenti permettono ai siti di riconoscere il computer o altro dispositivo del visitatore quando è utilizzato per accedere di nuovo a uno dei nostri siti, dopo la fine di una sessione di
                              navigazione e all'inizio di una nuova sessione di navigazione, essenzialmente per aiutare il visitatore a riconnettersi rapidamente al nostro sito.
                          </p>
                          <p>
                              Il presente sito, per ragioni strettamente tecniche, fa uso delle seguenti tipologie di cookies:
                              <br />- cookie tecnici e di sessione, ad esempio per evitare che - ove previsto - l'utente debba immettere più volte la password per accedere a sezioni riservate del sito, oppure per memorizzare la lingua preferita di navigazione, o
                              per memorizzare alcune caratteristiche tecniche del browser utilizzato per la navigazione (inclusa l'accettazione dei cookies).
                          </p>
                          <p>È possibile disattivare l'utilizzo dei cookies, ma scegliendo una tale opzione è probabile che il sito presenti dei malfunzionamenti, più o meno evidenti a seconda della sezione del sito che si intende visitare.</p>
                          <p>Per disattivare i cookies, a seconda del browser utilizzato, possiamo suggerire alcune guide (valide nel momento in cui questo documento è stato scritto).</p>
                          <h3>Chrome</h3>
                          <p>1. Eseguire il Browser Chrome</p>
                          <p>2. Fare click sul menù presente nella barra degli strumenti del browser a fianco della finestra di inserimento url per la navigazione</p>
                          <p>3. Selezionare Impostazioni</p>
                          <p>4. Fare clic su Mostra Impostazioni Avanzate</p>
                          <p>5. Nella sezione &ldquo;Privacy&rdquo; fare clic su bottone &ldquo;Impostazioni contenuti&ldquo;</p>
                          <p>6. Nella sezione &ldquo;Cookie&rdquo; è possibile modificare le seguenti impostazioni relative ai cookie:</p>
                          <ul>
                              <li>Consentire il salvataggio dei dati in locale</li>
                              <li>Modificare i dati locali solo fino alla chiusura del browser</li>
                              <li>Impedire ai siti di impostare i cookie</li>
                              <li>Bloccare i cookie di terze parti e i dati dei siti</li>
                              <li>Gestire le eccezioni per alcuni siti internet</li>
                              <li>Eliminazione di uno o tutti i cookie</li>
                          </ul>
                          <p>
                              Per maggiori informazioni visita la
                              <a href="https://support.google.com/accounts/answer/61416?hl=it" target="_blank">pagina dedicata</a>.
                          </p>
                          <h3>Mozilla Firefox</h3>
                          <p>1. Eseguire il Browser Mozilla Firefox</p>
                          <p>2. Fare click sul menù presente nella barra degli strumenti del browser a fianco della finestra di inserimento url per la navigazione</p>
                          <p>3. Selezionare Opzioni</p>
                          <p>4. Seleziona il pannello Privacy</p>
                          <p>5. Fare clic su Mostra Impostazioni Avanzate</p>
                          <p>6. Nella sezione &ldquo;Privacy&rdquo; fare clic su bottone &ldquo;Impostazioni contenuti&ldquo;</p>
                          <p>7. Nella sezione &ldquo;Tracciamento&rdquo; è possibile modificare le seguenti impostazioni relative ai cookie:</p>
                          <ul>
                              <li>Richiedi ai siti di non effettuare alcun tracciamento</li>
                              <li>Comunica ai siti la disponibilità ad essere tracciato</li>
                              <li>Non comunicare alcuna preferenza relativa al tracciamento dei dati personali</li>
                          </ul>
                          <p>8. Dalla sezione &ldquo;Cronologia&rdquo; è possibile:</p>
                          <ul>
                              <li>
                                  Abilitando &ldquo;Utilizza impostazioni personalizzate&rdquo; selezionare di accettare i cookie di terze parti (sempre, dai siti più visitato o mai) e di conservarli per un periodo determinato (fino alla loro scadenza, alla
                                  chiusura di Firefox o di chiedere ogni volta)
                              </li>
                              <li>Rimuovere i singoli cookie immagazzinati</li>
                          </ul>
                          <p>
                              Per maggiori informazioni visita la
                              <a href="https://support.mozilla.org/it/kb/Attivare%20e%20disattivare%20i%20cookie" target="_blank">pagina dedicata</a>.
                          </p>
                          <h3>Internet Explorer</h3>
                          <p>1. Eseguire il Browser Internet Explorer</p>
                          <p>2. Fare click sul pulsante Strumenti e scegliere Opzioni Internet</p>
                          <p>3. Fare click sulla scheda Privacy e nella sezione Impostazioni modificare il dispositivo di scorrimento in funzione dell'azione desiderata per i cookie:</p>
                          <ul>
                              <li>Bloccare tutti i cookie</li>
                              <li>Consentire tutti i cookie</li>
                              <li>
                                  Selezione dei siti da cui ottenere cookie: spostare il cursore in una posizione intermedia in modo da non bloccare o consentire tutti i cookie, premere quindi su Siti, nella casella Indirizzo Sito Web inserire un sito internet e
                                  quindi premere su Blocca o Consenti
                              </li>
                          </ul>
                          <p>
                              Per maggiori informazioni visita la
                              <a href="https://support.microsoft.com/it-it/products/windows?os=windows-10" target="_blank">pagina dedicata</a>.
                          </p>
                          <h3>Safari 6/7</h3>
                          <p>1. Eseguire il Browser Safari</p>
                          <p>2. Fare click su Safari, selezionare Preferenze e premere su Privacy</p>
                          <p>3. Nella sezione Blocca Cookie specificare come Safari deve accettare i cookie dai siti internet.</p>
                          <p>4. Per visionare quali siti hanno immagazzinato i cookie cliccare su Dettagli</p>
                          <p>
                              Per maggiori informazioni visita la
                              <a href="https://support.apple.com/kb/PH17191?locale=en_US&amp;viewlocale=it_IT" target="_blank">pagina dedicata</a>.
                          </p>
                          <h3>Safari iOS (dispositivi mobile)</h3>
                          <p>1. Eseguire il Browser Safari iOS</p>
                          <p>2. Tocca su Impostazioni e poi Safari</p>
                          <p>3. Tocca su Blocca Cookie e scegli tra le varie opzioni: &ldquo;Mai&rdquo;, &ldquo;Di terze parti e inserzionisti&rdquo; o &ldquo;Sempre&rdquo;</p>
                          <p>4. Per cancellare tutti i cookie immagazzinati da Safari, tocca su Impostazioni, poi su Safari e infine su Cancella Cookie e dati</p>
                          <p>
                              Per maggiori informazioni visita la
                              <a href="https://support.apple.com/it-it/HT201265" target="_blank">pagina dedicata</a>.
                          </p>
                          <h3>Opera</h3>
                          <p>1. Eseguire il Browser Opera</p>
                          <p>2. Fare click sul Preferenze poi su Avanzate e infine su Cookie</p>
                          <p>3. Selezionare una delle seguenti opzioni:</p>
                          <ul>
                              <li>Accetta tutti i cookie</li>
                              <li>Accetta i cookie solo dal sito che si visita: i cookie di terze parti e che vengono inviati da un dominio diverso da quello che si sta visitando verranno rifiutati</li>
                              <li>Non accettare mai i cookie: tutti i cookie non verranno mai salvati</li>
                          </ul>
                          <p>
                              Per maggiori informazioni visita la
                              <a href="https://www.opera.com/help/tutorials/security/privacy/" target="_blank">pagina dedicata</a>.
                          </p>
                          <p>
                              Se il programma che utilizzate per la navigazione sui siti internet non è tra quelli citati in precedenza, vi suggeriamo di utilizzare un motore di ricerca on line (google, yahoo, bing&hellip;) per capire come disattivare i cookies in
                              tale specifico browser.
                          </p>`,

            prodotti: 'Prodotti',
            prodotti_relativi_ordine: "Prodotti relativi all'ordine",
            prodotti_utilizzati: 'Prodotti utilizzati',
            prodotto: 'Prodotto',
            profilo_aggiornato: 'Profilo aggiornato con successo!',
            profilo_personale: 'Profilo personale',
            pulisci_date:
                "Pulisci l'orario di inizio e di fine per poter modificare manualmente il totale di ore svolte",
            quantita: 'Quantità',
            quantita_prodotto: 'Quantità prodotto',
            raggruppa_per: 'Raggruppa per',
            rapportino_inviato: 'Rapportino inviato con successo!',
            rapportino_ricevuto: 'Rapportino ricevuto',
            relazione_intervento: 'Relazione intervento',
            report: 'Report',
            resoconto: 'Resoconto',
            resoconto_commesse: 'Resoconto commesse',
            righe_effettive: 'Righe effettive',
            rimuovi: 'Rimuovi',
            riprendi_timer: 'Riprendi timer',
            ripristina: 'Ripristina',
            risorsa: 'Apprendista',
            apprendisti: 'Apprendisti',
            rispondi_a: 'Rispondi a',
            risposta_a: 'Risposta a',
            salva: 'Salva',
            scarica: 'Scarica',
            scorciatoia_ctrl_b: 'Apri/chiudi: CTRL + B',
            scrivi_messaggio: 'Scrivi il tuo messaggio...',
            segnala_come_concluso: 'Segnala come concluso',
            seleziona: 'Seleziona',
            seleziona_filtro: 'Seleziona filtro',
            seleziona_foto: 'Seleziona foto',
            seleziona_mese: 'Scegli il mese',
            seleziona_tutti: 'Seleziona tutti',
            seleziona_utente: 'Seleziona utente',
            selezionare_cliente: 'Seleziona il cliente per il quale si vuole creare il rapportino',
            selezionare_data_intervento: "Seleziona la data dell'intervento",
            selezionare_email_invio_rapportino: "Seleziona l'email a cui inviare il rapportino",
            selezionare_luogo_intervento: 'Seleziona il luogo di intervento',
            send_rapportino_cliente: 'Rapportino cliente mandato con successo',
            sequenziale: 'Sequenziale',
            settimana: 'Settimana',
            settimana_attuale: 'Settimana attuale',
            si: 'Si',
            software_inedito_m2sistemi: 'Software edito da M2 Sistemi S.r.l.',
            sta_scrivendo: 'Sta scrivendo',
            standard: 'Standard',
            stato: 'Stato',
            stato_commessa_aggiornato: 'Stato commessa aggiornato con successo!',
            stato_lavoro: 'Stato lavoro',
            su: 'su',
            su_cosa_hai_lavorato: 'Su cosa hai lavorato?',
            successo: 'Successo',
            tags: 'Tag',
            telefono: 'Telefono',
            tempo_rimanente: 'Tempo rimanente',
            termina_modifica: 'Termina prima la modifica in corso!',
            testo_copiato: 'Testo copiato negli appunti',
            testo_notifica: 'Testo notifica',
            tipo: 'Tipo',
            tipologia_destinatario: 'Tipologia destinatario',
            tipologia_file_non_valida: 'La tipologia del file non è supportata',
            tipologia_turno: 'Tipologia turno',
            titolo: 'Titolo',
            titolo_cambio_password: 'Cambio password',
            torna_indietro: 'Torna indietro',
            totale_ore: 'Totale ore',
            totale_ore_turno: 'Ore totali turno',
            trasferta: 'Trasferta',
            tu: 'Tu',
            tutti_i_campi_devono_essere_compilati:
                'Tutti i campi obbligatori devono essere compilati',
            url: 'URL',
            username: 'Username',
            username_destinatario: 'Username destinatario',
            username_esistente: 'Username già esistente',
            username_in_uso: 'Username già in uso',
            username_mittente: 'Username mittente',
            utente: 'Utente',
            utenti: 'Utenti',
            utenti_con_piu_messaggi: 'Utenti con più messaggi',
            utenti_online: 'Utenti online',
            utenti_totali: 'Utenti totali',
            vai_a_gestori: 'Vai agli gestori',
            vai_a_gruppi: 'Vai alle anagrafiche dei gruppi',
            vai_a_apprendisti: 'Vai alle apprendisti',
            verifica_campi: 'Verifica i campi inseriti',
            visualizza_a_schermo_intero: 'Visualizza a schermo intero',
            visualizza_lavori_previsti: 'Visualizza lavori previsti',
            visualizza_per: 'Visualizza per',
            visualizza_righe: 'Visualizza righe',
            visualizza_utenti_online: 'Visualizza utenti online',
            visualizzi_da: 'Visualizzi da',
            zero_ore_lavorate_breve: '0 ore lav.',
        },
        en: {
            a: 'to',
            a_tempo: 'to',
            ad_ore: 'by the hour',
            admin: 'admin',
            aggiorna: 'Update',
            aggiorna_grafico: 'Update chart',
            aggiorna_tabella: 'Update the table',
            aggiornamento_eseguito: 'Successful update!',
            aggiungi: 'Add',
            aggiungi_note: 'Add notes',
            allega_file: 'Attach a file...',
            amministratore: 'Administrator',
            amministratore_del_gruppo: 'Group administrator',
            anno: 'Year',
            annulla: 'cancel',
            annulla_modifica: 'Cancel Edit',
            applica: 'Apply',
            archivia: 'Archive',
            archiviazione_eseguita: 'Storage performed successfully!',
            archivio_elimina_selezionati: 'Delete selected',
            autenticazione_2FA: '2FA authentication',
            avvia_timer: 'Start timer',
            avviso_date_con_date_disabilitate:
                'If the selected date range includes disabled dates, the system will generate as many associations as there are date ranges that are found.',
            azioni: 'Actions',
            benvenuto_descrizione: 'Business chat at your fingertips',
            benvenuto_titolo: 'Elisa Gazzera',
            benvenuto_utente: 'Welcome',
            blocca_timer_per_disconnetterti: 'Lock the timer to disconnect',
            calcola_data_fine: 'Calculate estimated date end',
            calendario: 'Calendar',
            cambia_immagine: 'Change image',
            cambia_password: 'Change password',
            cambia_tema: 'Change theme',
            cambio_lingua: 'Change of language in progress ...',
            campo_obbligatorio: '(*) = mandatory data',
            campo_richiesto: 'required field',
            carica_file: 'Select or drag one or more files to upload',
            caricamento_dati: 'loading data in progress ...',
            categoria: 'Category',
            categorie: 'Categories',
            categorie_utenti: 'User Categories',
            cerca: 'Search...',
            cerca_gif: 'Look for a gif ...',
            chiudi: 'Close',
            clicca_per_aprire_messaggio_fissato: 'Click to open the pinned message',
            clicca_per_rimuovere_messaggio_fissato: 'Click to remove the pinned message',
            cliente: 'Customer',
            codice: 'Code',
            codice_autenticazione: 'authentication code',
            codice_inviato: 'Code sent! Check your email to continue.',
            codice_obbligatorio: 'Code is mandatory!',
            codice_prodotto: 'Product code',
            codice_prodotto_breve: 'Product Code',
            codice_recupera_password_verificato:
                'code verified correctly, proceed with entering the new password',
            codice_testo:
                'Enter the code that was sent to you by e-mail before the expiry of the time',
            cognome: 'Surname',
            cognome_utente: 'user surname',
            collaboratori_esterni: 'external resources',
            colore: 'Color',
            commessa: 'Shop assistant',
            commessa_aggiornata: 'Successfully updated saleswoman!',
            commessa_duplicata: 'Successfully duplicated saleswoman!',
            commessa_eliminata: 'Saleswoman successfully eliminated!',
            commessa_ricevuta: 'order received',
            commessa_risorsa_aggiornata: 'Successfully updated saleswoman!',
            commesse_giornaliere: 'daily orders',
            commesse_importate: 'Successfully imported orders',
            completato: 'Completed',
            concludi: 'Conclude',
            conclusa: 'concluded',
            concluso: 'concluded',
            conferma: 'Confirmation',
            conferma_archivia:
                'Are you sure you want to store the selected data? This operation will be reversible from the "Archive" section.',
            conferma_creazione_lavoro:
                'One or more users have the end date of the job after the estimated end date of the order. Do you want to continue?',
            conferma_elimina:
                'Are you sure you want to delete the selected data? This operation will not be reversible.',
            conferma_mandare_rapportino:
                'Do you confirm that you want to send the report to the customer?',
            configurazione_orari_giorni: 'Timetable configuration days',
            copia_desc_beep: 'Copy Description Report',
            copia_descrizione_rapportino: 'Copy Report Description for Bee.p',
            copia_orario_per_giorni_seguenti: 'copy for subsequent days',
            costo_finale: 'Final cost',
            crea: 'Create',
            creatoIl: 'Created the',
            creazione_eseguita: 'Creation done successfully!',
            da_pianificare: 'to plan',
            da_tempo: 'from',
            data: 'Date',
            data_fine: 'End date',
            data_fine_maggiore_data_inizio: 'The end date must be greater than the start date',
            data_fine_stimata: 'Estimated end date',
            data_inizio: 'Start date',
            data_intervento: 'Date of intervention',
            data_nascita: 'Date of birth',
            data_non_valida: 'The selected date is not valid',
            data_popover_mancante: 'Missing final date',
            data_ultimo_login: 'Last login',
            date: 'Dates',
            date_utente_non_disponibile: 'Dates where the user is not available',
            dati_non_disponibili: 'Data not available',
            dati_personali: 'Personal data',
            denominazione: 'Name',
            descrizione: 'Description',
            descrizione_fase: 'Phase description',
            descrizione_prodotto: 'Product description',
            deseleziona_tutti: 'Uncheck all',
            destinatario: 'Recipient',
            dettagli_base: 'Basic details',
            dettagli_cliente: 'Customer Details',
            dettagli_fase: 'Phase details',
            dettagli_lavoro: 'Job details',
            dettagli_prodotto: 'Product details',
            dettagli_utente: 'User details',
            di: 'of',
            dimensione_file_non_valida: 'The file exceeds the maximum allowed size, 10MB',
            dimensione_massima_file: 'The file exceeds the maximum allowed size, 5MB',
            dipendente_cliente: 'Customer employee',
            disponibile: 'Available',
            documento: 'Document',
            duplica_commessa: 'Duplicate order',
            durata: 'Duration',
            durata_attuale: 'hours att.',
            durata_giornata_lavorativa: 'Working day duration',
            durata_prevista: 'hours before',
            elementi: 'elements',
            elimina: 'Delete',
            elimina_commessa: 'Delete saleswoman',
            eliminazione_eseguita: 'Successful elimination!',
            email: 'email',
            emailResetPassInviata: 'Email for password reset sent to the specified user.',
            email_cliente: 'Customer email',
            email_invio_rapportino: 'Email I send report',
            error_effettua_login: 'Log in to continue',
            error_sottotitolo_401:
                "Sorry, but you don't have the necessary permissions to complete the operation. Please try again later and if the error persists, contact our technical team providing details on the operation. Thanks for your understanding and patience.",
            error_sottotitolo_404:
                "We apologize, but the page you are looking for is not available or has been moved. Check the URL and make sure it's correct. If the problem persists, it could be due to an outdated link or a deleted resource.",
            error_sottotitolo_generale:
                'Sorry, an unexpected error occurred during the operation. Please try again later and if the error persists, contact our technical team providing details on the operation. Thanks for your understanding and patience.',
            error_titolo_401: 'Unauthorized',
            error_titolo_404: 'Page not found',
            error_titolo_generale: 'Error encountered',
            error_torna_pagina_iniziale: 'Back to home page',
            errore: 'Mistake',
            errore_copia: 'Error copying to clipboard!',
            errore_generazione_qr: 'QR Generation Error!',
            esporta: 'Export',
            fase: 'Phase',
            favorite_page_pagina_aggiunta: 'Page added to favorites',
            favorite_page_pagina_rimossa: 'Page removed from favorites',
            ferma_timer: 'Stop timer',
            file_caricato: 'Uploaded file',
            file_e_documenti: 'Files and documents',
            file_media: 'File / Media',
            file_non_supportato: 'Unsupported file',
            file_troppo_grande: 'too big file',
            fino_a: 'Until',
            fornitura: 'Supply',
            foto: 'Photo',
            genera_password: 'Generate passwords',
            genera_qr: 'Generate QR',
            gestione_orari: 'Time management',
            grafico: 'Graphic',
            id: 'ID',
            immagine_gruppo: 'Group image',
            immagine_profilo: 'Profile picture',
            immagine_profilo_aggiornata: 'Successfully updated profile picture!',
            importa: 'Import',
            in_corso: 'In progress',
            inattivita_descrizione_1: 'Prolonged inactivity was found.',
            inattivita_descrizione_2: 'For security reasons you have been disconnected.',
            inattivita_titolo: 'Inactivity detected!',
            indirizzo_ip: 'IP address',
            indirizzo_luogo_intervento: 'Address Place of Intervention',
            info_aggiuntive: 'Additional information',
            informazione: 'Information',
            informazioni_breve: 'Info',
            informazioni_generali: 'General information',
            inserire_ore_lavorate_effettive: 'Enter the actual hours worked',
            inserire_ore_lavorate_minimo_0_5: 'Enter the hours worked (minimum 0.5)',
            inserire_relazione_intervento: 'Enter the report of the intervention',
            inserisci_mail_valida: 'Enter a valid email',
            installa_pwa: 'Install PWA',
            invia_credenziali: 'Send credentials by email',
            invia_file: 'Send files',
            invia_rapportino: 'Send Report',
            inviata_amministrazione: 'sent to the Administration',
            inviata_cliente: 'sent to the customer',
            km_percorsi: 'km traveled',
            legenda: 'legend',
            legenda_categorie_commesse: 'Legenda Categories Committed',
            legenda_tag: 'Legend Tags',
            lista: 'List',
            livello: 'Level',
            login_aggiorna_accedi: 'Update and login',
            login_attendi: 'Wait ...',
            login_attendi_riprova: 'Wait to try again!',
            login_benvenuto: 'Welcome!',
            login_campi_obbligatori: 'Enter both username and password to continue',
            login_campo_non_sicuro: 'Unsafe field!',
            login_codice_scaduto: 'Code expired! Try again to continue',
            login_conferma_password: 'Confirm password',
            login_controlla_mail: 'Check emails to continue',
            login_effetta_accesso: 'Log in',
            login_email_reset_pass_inviata: 'Email for password reset sent to the specified user.',
            login_livello_sicurezza_password: 'Password security level',
            login_password: 'Password',
            login_password_dimenticata: 'Forgot your password?',
            login_password_non_uguali: "Passwords don't match",
            login_reset_password: 'Reset the password',
            login_submit_text: 'Sign in',
            login_suggerimenti_password: 'Password tips',
            login_suggerimenti_password_1:
                'The password must contain at least one lowercase letter',
            login_suggerimenti_password_2:
                'The password must contain at least one uppercase letter',
            login_suggerimenti_password_3: 'The password must contain at least one number',
            login_suggerimenti_password_4:
                'The password must contain at least one special character',
            login_suggerimenti_password_5: 'The password must contain at least 8 characters',
            login_timeout_codice: 'Verification code expired',
            login_troppe_richieste: 'You have made too many requests!',
            login_usa_password: 'Use your password',
            login_username: 'username',
            login_username_reset_password:
                "Enter the username for which you want to request the password reset in the 'Username' field.",
            login_utente_non_trovato: 'Could not find the inserted user!',
            logout_conferma_disconnessione: 'Confirmation',
            logout_disconnessione: 'Disconnection',
            logout_disconnetti: 'Disconnect',
            logout_messaggio_disconnessione: 'Are you sure you want to disconnect?',
            luogo_intervento: 'place of intervention',
            media_caricati: 'loaded media',
            membri: 'Membership',
            menu_gestori: 'Administrators',
            menu_gestori_tooltip: 'Personal data - administrators',
            menu_anagrafiche: 'Personal data',
            menu_categorie_commesse: 'Categories committed',
            menu_categorie_commesse_tooltip: 'Personal data - Categories committed',
            menu_categorie_utenti: 'Resource categories',
            menu_categorie_utenti_tooltip: 'Data - Resource Categories',
            menu_commesse: 'committed',
            menu_commesse_occupazione: 'Occupation',
            menu_commesse_occupazione_tooltip: 'orders - occupation',
            menu_commesse_pianificazione: 'Planning',
            menu_commesse_pianificazione_tooltip: 'orders - planning',
            menu_commesse_resoconto: 'Report',
            menu_commesse_resoconto_apprendisti: 'RESOURCE REPORT',
            menu_commesse_resoconto_apprendisti_tooltip: 'orders - resource report',
            menu_commesse_resoconto_tooltip: 'orders - report',
            menu_dashboard: 'Dashboard',
            menu_gruppi: 'Chat groups',
            menu_gruppi_tooltip: 'Master Data - Chat Groups',
            menu_impostazioni: 'Settings',
            menu_log: 'Logs',
            menu_log_messaggi: 'Message log',
            menu_log_messaggi_tooltip: 'log - messages',
            menu_log_tecnici: 'Technical logs',
            menu_log_tecnici_tooltip: 'log - technicians',
            menu_occupazione: 'Occupation',
            menu_priorita_commesse: 'Priority orders',
            menu_priorita_commesse_tooltip: 'Personal data - Priority orders',
            menu_apprendisti: 'Resources',
            menu_apprendisti_tooltip: 'Personal data - resources',
            menu_tag_commesse: 'Tags orders',
            menu_tag_commesse_tooltip: 'Personal data - Tags orders',
            menu_utilita: 'Utility',
            menu_utilita_archivio: 'Archive',
            menu_utilita_archivio_tooltip: 'Utility - Archive',
            menu_utilita_calendario_eventi: 'Events calendar',
            menu_utilita_calendario_eventi_tooltip: 'Utility - Event Calendar',
            menu_utilita_chat: 'Chat',
            menu_utilita_chat_tooltip: 'Utility - Chat',
            mese: 'Month',
            messaggi: 'Messages',
            messaggi_da_leggere: 'Messages to read',
            messaggio_fissato: 'Fixed message',
            messaggi_per_giorno: 'Messages per day',
            messaggi_solo_gestori: 'Only group administrators can write',
            messaggi_solo_gestori_breve: 'Only administrators can write',
            messaggio: 'Message',
            messaggio_completo: 'Full message',
            messaggio_conclusione_commessa: 'report the order as concluded?',
            messaggio_conferma_eliminazione_lavoro: 'Successful elimination',
            messaggio_conferma_eliminazione_selezionati: 'Data deleted successfully!',
            messaggio_conferma_ripristino_selezionati: 'Successfully restored data!',
            messaggio_duplicazione: 'Duplicate the order?',
            messaggio_eliminato: 'Message deleted',
            messaggio_eliminazione: 'Eliminate the order?',
            messaggio_eliminazione_lavoro: 'Are you sure you want to delete the following job?',
            messaggio_eliminazione_selezionati:
                'Are you sure you want to delete the selected data?',
            messaggio_manda_rapportino: 'sends the report to the customer',
            messaggio_ripristina_selezionati: 'Are you sure you want to restore the selected data?',
            mezza_giornata: 'Half day',
            mittente: 'Sender',
            modifica: 'Modification',
            modifica_lavori: 'Edit jobs',
            modificato: 'Modified',
            mostra: '(Show the full message)',
            mostra_dashboard_commesse: 'Show orders dashboards',
            mostra_dettagli: 'Show details',
            mostra_informazioni: 'Show additional information',
            mostra_occupazione: 'Show occupation',
            mostra_ore: 'View the number of hours',
            mostrando: 'showing',
            n_fase: 'Phase number',
            nessun_cliente_selezionato: 'No customer selected',
            nessun_dato_archiviato: 'There is no data marked as archived',
            nessun_dato_disponibile: 'No data available',
            nessun_messaggio_da_leggere: 'You have no message to read. Bravo!',
            nessun_parametro: 'No parameters',
            nessuna_chat_selezionata: 'No chat selected',
            nessuna_email_cliente: 'No email present for the selected customer',
            no: 'No',
            no_concluso: 'not concluded',
            no_messaggi_nuovi: 'No new messages have been sent',
            nome: 'Name',
            nome_utente: 'Username',
            nominativo: 'Nominative',
            nominativo_cliente: 'Customer name',
            nominativo_dipendente: 'Customer employee name',
            non_disponibile: 'Unavailable',
            non_programmato: 'not programmed',
            note: 'Notes',
            note_amministrative: 'Administrative notes',
            note_amministrative_breve: 'Admin notes.',
            note_intervento: 'Notes Intervention',
            numero: 'Number',
            numero_commessa: 'Committed name',
            numero_documento: 'Document No',
            nuovo_messaggio: 'You got a new message',
            occupazione: 'Occupation',
            offline: 'Offline',
            oggi: 'Today',
            online: 'online',
            online_ora: 'online now',
            oppure: 'or',
            opzioni_disponibili: 'Available options',
            ora_fine: 'End time',
            ora_fine_obbligatoria: 'Mandatory end time',
            ora_fine_turno: 'End of shift time',
            ora_inizio: 'Now I start',
            ora_inizio_obbligatoria: 'Now mandatory start',
            ora_inizio_turno: 'Turn start now',
            ore_effettive: 'Actual hours',
            ore_lavorate: 'hours worked',
            ore_lavorate_breve: 'Work hours',
            ore_lavorate_breve_header: 'Work hours',
            ore_lavorate_effettive: 'Actual worked hours',
            ore_lavorate_effettive_breve_header: 'hours Eff.',
            ore_previste: 'scheduled hours',
            ore_programmate: 'scheduled hours',
            ore_toggle_popover_mancanti: 'Missing timing',
            ore_viaggio: 'travel hours',
            panoramica_sistema: 'System overview',
            parametri: 'Parameters',
            parametri_prodotto: 'Product parameters',
            password: 'Password',
            password_aggiornata: 'Password successfully updated!',
            password_cambiata: 'Password changed successfully!',
            password_gia_usata:
                'The password has already been used previously! Enter another one to continue.',
            percentuale_completamento: 'Progress',
            personali: 'personal',
            pianifica: 'Plan',
            pianificata: 'planned',
            pianificato: 'planned',
            pianificazione: 'Planning',
            preferiti: 'Favorites',
            priorita: 'Priority',
            priorita_lavoro: 'Work priority',
            privacy_policy:
                '<h1> Information for the processing of data </h1> <p> This page describes the methods of managing the site with reference to the processing of the personal data of users who consult it, as well as methods and purposes of processing personal data. </p> <p> This is an information provided also pursuant to of Article 13-14 EU Reg. 2016/679 to those who interact with web services accessible electronically starting from the address. </p> <p> The information is provided only for the site in question and not for other websites if necessary available through our links, for which it is not responsible in any way. </p> <p> in the capacity of data controller of your personal data, pursuant to and for the purposes of the EU Reg. 2016/679 - GDPR, hereby informs you that the aforementioned legislation provides for the protection of interested parties with respect to the processing of personal data and that this processing will be based on the principles of correctness, lawfulness, transparency and protection of your confidentiality and rights. </p> <p>Your personal data will be processed in accordance with the legislative provisions of the aforementioned legislation and the confidentiality obligations provided therein. IT and the software procedures used to operate this website acquire, during their normal operation, some personal data whose transmission is implicit in the use of Internet communication protocols. This is information that is not collected to be associated with identified interested parties, but which by their very nature could, through processing and association with data held by third parties, allow the identification of users. This category of data includes IP addresses or domain names of computers used by users connecting to the site, addresses in URI (Uniform Resource Identifier) notation of the requested resources, the time of the request, the method used in submitting the request to the server, the file size obtained in response, the numerical code indicating the status of the response given by the server (successful, error, etc.) and other parameters relating to the user\'s operating system and computer environment. These data are used for the sole purpose of obtaining anonymous statistical information on the use of the site and to check its correct functioning and are deleted immediately after processing. The data could be used to ascertain responsibility in the event of hypothetical computer crimes against the site. </p> <h3> Data provided voluntarily by the user </h3> <p> The optional, explicit and voluntary sending of e-mails to the addresses indicated on this site, as well as the compilation of the forms for sending specific requests entail the next acquisition of the sender\'s address, necessary to respond to requests, as well as any other personal data included in the letter or form. <br /> Summary information specifications are reported or displayed on the pages of the site prepared for particular services on request. </p> <h2>Consequences of the refusal to provide data </h2> <p> Apart from what is specified for navigation data, the user is free to provide the personal data reported in the application forms, registration to mailing lists or in any case indicated in contacts to request sending information, technical or commercial material or other communications. Failure to provide them may make it impossible to obtain what is requested. </p> <h2>METHOD OF TREATMENT </h2> <p> The data are mainly processed with electronic and computer tools and stored both on computer media and on paper and on any other type of suitable support, in compliance with the procedures set out in art. 6, 32 of the GDPR and through the adoption of the appropriate security measures envisaged. To prevent data loss, illegal or incorrect use and unauthorized access. We inform you that, to provide a complete service, our portal may contain links to other websites, not managed by us. We are not responsible for errors, contents, cookies, publications of illicit moral content, advertising, banners or files that do not comply with the regulations in force and compliance with the privacy legislation by sites we manage to which we refer. To improve the service offered, an immediate report of malfunctions, abuses or suggestions to the e-mail address is welcome. Your data will be processed only by personnel expressly authorized by the Data Controller. </p> <h2>FINALITY OF THE TREATMENT </h2> <p> The data processing will be carried out to: <br /> - give the possibility to access the public and / or confidential sections of the site; <br /> - implement the activation and maintenance of any online services subscribed; <br /> - perform the obligations under laws or regulations; <br /> - The protection of the owner in court; <br /> - Send commercial or promotional information material <br /> - allow constant monitoring of the effectiveness of the proposed service. </p> <h2>Subjects to whom personal data may be communicated </h2> <p> The personal data relating to the processing in question may also be communicated to subjects who are granted the right to access your personal data by law or secondary and / or community regulations. In addition, some data can be communicated and disseminated to Internet operators uses for the management of their domains. The dissemination of the collected data is not foreseen. </p> <h2>Data retention period </h2> <p> We point out that, in compliance with the principles of lawfulness, limitation of purposes and minimization of data, pursuant to art. 5 of the GDPR, the retention period of your personal data is 15 years. At the expiry of the aforementioned retention period, the personal data will be automatically deleted. </p> <h2>Rights of the interested parties</h2> <p>EU 2016/679: Art. 15, 16, 17, 18, 19, 20, 21, 22 - rights of the interested party </p> <p> 1. The interested party has the right to obtain confirmation of the existence or not of personal data concerning him, even if not yet registered, and their communication in an intelligible form. </p> <p> 2. The interested party has the right to obtain the indication: <br /> A. the origin of personal data; <br /> B. the purposes and methods of processing; <br /> C. the logic applied in the case of treatment carried out with the aid of electronic tools; <br /> D. the identification details of the owner, the managers and the designated representative pursuant to article 5, paragraph 2; <br /> and. of the subjects or categories of subjects to whom the personal data may be communicated or who may become aware of them as designated representative in the territory of the State, as managers or persons in charge. </p> <p> 3. The interested party has the right to obtain: <br /> a. updating, rectification or, when interested, the integration of data; <br /> B. the cancellation, transformation into anonymous form or blocking of data processed in violation of the law, including those whose conservation is not necessary in relation to the purposes for which the data were collected or subsequently processed; <br /> C. the attestation that the operations referred to in letters a) and b) have been brought to the attention, also as regards their content, of those to whom the data have been communicated or disseminated, except in the case in which this fulfillment proves impossible or involves the use of means <br /> D. manifestly disproportionate to the protected right; <br /> and. data portability. </p> <p> 4. The interested party has the right to oppose, in whole or in part: <br /> a. for legitimate reasons to the processing of personal data concerning him, even if pertinent to the purpose of the collection; <br /> B. to the processing of personal data concerning him for the purpose of sending advertising or direct sales material or for carrying out researches of <br /> c. MARKET OR COMMERCIAL COMMUNICATION </p> <p> The user has the right to obtain the cancellation from the Data Controller (right to be forgotten), the limitation, updating, rectification, portability, opposition to the processing of personal data concerning you, as well as in general can exercise all The rights provided for by art. 15, 16, 17, 18, 19, 20, 21, 22 of the GDPR. </p> <p>To exercise the rights listed above, the interested party must make a written request by e-mail.</p> <p></p> <h2>cookies</h2> <p> Cookies mean a textual element that is inserted in the hard disk of a computer or other device from the provider of the online service to visitors to the website. Cookies can collect information about visitors\' habits about using the aforementioned website, recording the activities of their computer or other device regarding the aforementioned site, for example when it comes to making purchases. </p> <h3> Cookies can be: </h3> <h3> proprietary cookies (also called first-party) </h3> <p> Proprietary cookies are cookies that are saved directly on your computer or other device. They may include cookies such as session cookies and persistent cookies (described below).</p> <p>Proprietary cookies can be used to follow the movements made by the visitor\'s computer or other device by consulting the site, for example for analysis purposes.</p> <h3>Third Parts </h3> <p> No third party cookies are stored </p> <h3> Session cookies </h3> <p> The duration between the moment in which the internet browser opens and the moment in which it is closed is called a browsing session. Session cookies are cookies stored on the visitor\'s computer or other device during a browsing session, but which expire and are normally deleted at the end of a browsing session. </p> <h3>persistent cookies</h3> <p> Persistent cookies are cookies stored on the visitor\'s computer or other device during a browsing session, but which remain on the computer or other device after the end of the aforementioned browsing session (eg registration of the password). Persistent cookies allow sites to recognize the visitor\'s computer or other device when it is used to access one of our sites again, after the end of a browsing session and at the beginning of a new browsing session, essentially to help the visitor to quickly reconnect to our site. </p> <p> This site, for strictly technical reasons, makes use of the following types of cookies: <br /> - technical and session cookies, for example to avoid that - where applicable - the user must enter the password several times to access reserved sections of the site, or to store the preferred navigation language, or to store some technical characteristics of the browser used for navigation (including the acceptance of cookies). </p> <p>It is possible to disable the use of cookies, but by choosing such an option it is likely that the site has malfunctions, more or less evident depending on the section of the site you intend to visit. </p> <p> To disable cookies, depending on the browser used, we can Suggest some guides (valid at the time this document was written).</p> <h3>Chrome</h3> <p>1. Run Chrome Browser</p> <p>2. Click on the menu in the browser toolbar next to the URL entry window for navigation </p> <p> 3. Select Settings</p> <p>4. Click Show Advanced Settings</p> <p>5. in the & ldquo; Privacy & rdquo; section; Click button &ldquo;content settings&ldquo;</p> <p>6. in the & ldquo; Cookie & rdquo; section You can change the following cookie-related settings:</p> <ul> <li>Allow data saving locally</li> <li>Modify local data only until the browser is closed</li> <li>Hold the sites to set cookies</li> <li>Blocking third-party cookies and site data</li> <li>Managing exceptions for some websites</li> <li>Deleting one or all cookies</li> </ul> <p> For more information visit <a href="https://support.google.com/accounts/answer/61416?hl=it" target="_blank"> dedicated page </a>. </p> <h3>Mozilla Firefox</h3> <p>1. Run the Mozilla Firefox</p> <p>2 browser. Click on the menu in the browser toolbar next to the URL entry window for navigation </p> <p> 3. Select Options</p> <p>4. Select the Privacy</p> <p>5 panel. Click Show Advanced Settings</p> <p>6. in the & ldquo; Privacy & rdquo; section; Click on the &ldquo;content settings&ldquo;</p> <p>7 button. in the & ldquo; tracking & rdquo; section; You can change the following cookie-related settings:</p> <ul> <li>Ask sites not to track any tracking</li> <li>Communicate the sites to be tracked</li> <li>Do not communicate any personal data tracking preferences</li> </ul> <p>8. from the & ldquo; Chronology & rdquo; section; You can: </p> <ul> <li> by enabling &ldquo;Use Custom Settings&rdquo; select to accept third-party cookies (always, from the most visited sites or never) and to keep them for a specific period (until their expiry, when Firefox is closed or to ask each time) </li> <li>Remove individual cookies Stored</li> </ul> <p> For more information visit <a href="https://support.mozilla.org/it/kb/Activate%20E%20Disable%20i%20cookie" target = "_blank"> dedicated page </a>. </p> <h3>Internet Explorer</h3> <p>1. Run Internet Explorer</p> <p>2 browser. Click the Tools button and choose Internet Options</p> <p>3. Click on the Privacy tab and in the Settings section, modify the slider according to the desired action for cookies: </p> <ul> <li> Block all cookies </li> <li> Allow all cookies </li> <li> Selection of sites from which to obtain cookies: Move the cursor to an intermediate position so as not to block or allow all cookies, then press on Sites, in the Website Address box, insert a website and then press on Block or Allow </li> </ul> <p> for more information visit the <a href="https://support.microsoft.com/it-it/products/windows?os=windows-10" target="_blank"> dedicated page </a>. </p> <h3>Safari 6/7 </h3> <p>1. Run Safari Browser</p> <p>2. Click Safari, select Preferences and press Privacy</p> <p>3. In the Block Cookies section, specify how Safari must accept cookies from websites.</p> <p>4. To view which sites have stored cookies click on Details </p> <p> For more information visit <a href="https://support.apple.com/kb/ph17191?locale=en_us&amp;viewlocale=en_it" target="_blank"> dedicated page </a>. </p> <h3> iOS safari (mobile devices) </h3> <p>1. Run Safari iOS browser</p> <p>2. Tap on Settings and then Safari </p> <p>3. Tap on Block Cookies and choose from the various options: & ldquo; never & rdquo ;, & ldquo; third parties and advertisers & rdquo; or & ldquo; always & rdquo; </p> <p> 4. To delete all cookies stored by Safari, tap on Settings, then on Safari and finally on Delete Cookies and Data</p> <p> For more information visit <a href="https://support.apple.com/it-it/ht201265" target="_blank"> dedicated page </a>. </p> <h3>work</h3> <p>1. Run Browser Opera</p> <p>2. Click on the Preferences then on Advanced and finally on Cookies </p> <p> 3. Select one of the following options:</p> <ul> <li>Accept all cookies</li> <li>Accept cookies only from the site you visit: Third-party cookies that are sent from a domain other than the one you are visiting will be rejected</li> <li>Do not accept Never cookies: all cookies will never be saved </li> </ul> <p> For more information visit the <a href="https://www.opera.com/help/tutorials/security/privacy/"target="_blank">page dedicated </a>. </p> <p> If the program you use for browsing the websites is not among those mentioned above, we suggest you use an online search engine (Google, Yahoo, Bing & hellip;) to understand how to disable cookies in this specific browser. </p>',
            prodotti: 'Products',
            prodotti_relativi_ordine: 'Order-related products',
            prodotti_utilizzati: 'Products used',
            prodotto: 'Product',
            profilo_aggiornato: 'Profile updated successfully!',
            profilo_personale: 'Personal profile',
            pulisci_date:
                'Clean the start and end times to be able to manually change the total number of hours',
            quantita: 'Amount',
            quantita_prodotto: 'Product quantity',
            raggruppa_per: 'Group by',
            rapportino_inviato: 'Report sent successfully!',
            rapportino_ricevuto: 'Report received',
            relazione_intervento: 'Intervention report',
            report: 'Reports',
            resoconto: 'Report',
            resoconto_commesse: 'Order report',
            righe_effettive: 'actual lines',
            rimuovi: 'Remove',
            riprendi_timer: 'Resume timer',
            ripristina: 'Restore',
            risorsa: 'Resource',
            apprendisti: 'Resources',
            rispondi_a: 'Reply to',
            risposta_a: 'Answer to',
            salva: 'Salvo',
            scarica: 'Discharge',
            scorciatoia_ctrl_b: 'Open/Close: Ctrl+B',
            scrivi_messaggio: 'Write your message ...',
            segnala_come_concluso: 'Report as concluded',
            seleziona: 'Select',
            seleziona_filtro: 'Select Filter',
            seleziona_foto: 'Select Photos',
            seleziona_mese: 'Choose the month',
            seleziona_tutti: 'Select All',
            seleziona_utente: 'Select User',
            selezionare_cliente: 'Select the customer for whom you want to create the report',
            selezionare_data_intervento: 'Select the date of the intervention',
            selezionare_email_invio_rapportino: 'Select the email to send the report to',
            selezionare_luogo_intervento: 'Select the place of intervention',
            send_rapportino_cliente: 'Report customer successfully sent',
            sequenziale: 'sequential',
            settimana: 'Week',
            settimana_attuale: 'Current week',
            si: 'One',
            software_inedito_m2sistemi: 'Unpublished software M2 Sistemi S.r.l.',
            sta_scrivendo: 'Is writing',
            standard: 'Standard',
            stato: 'State',
            stato_commessa_aggiornato: 'Successfully updated order!',
            stato_lavoro: 'Status job',
            su: 'on',
            su_cosa_hai_lavorato: 'What have you worked on?',
            successo: 'Success',
            tags: 'tags',
            telefono: 'Phone',
            tempo_rimanente: 'Remaining time',
            termina_modifica: 'Finish the current change first!',
            testo_copiato: 'Text copied to the clipboard',
            testo_notifica: 'Notification text',
            tipo: 'Type',
            tipologia_destinatario: 'recipient type',
            tipologia_file_non_valida: 'File type is not supported',
            tipologia_turno: 'Round type',
            titolo: 'Title',
            titolo_cambio_password: 'Change password',
            torna_indietro: 'Come back',
            totale_ore: 'Total hours',
            totale_ore_turno: 'Total shift hours',
            trasferta: 'Transfer',
            tu: 'You',
            tutti_i_campi_devono_essere_compilati: 'All required fields must be completed',
            url: 'URLs',
            username: 'Username',
            username_destinatario: 'Recipient username',
            username_esistente: 'Already existing username',
            username_in_uso: 'Username already in use',
            username_mittente: 'Sender username',
            utente: 'User',
            utenti: 'users',
            utenti_con_piu_messaggi: 'Users with multiple messages',
            utenti_online: 'Online users',
            utenti_totali: 'Total users',
            vai_a_gestori: 'Go to the administrators',
            vai_a_gruppi: 'Go to the group data',
            vai_a_apprendisti: 'Go to the resources',
            verifica_campi: 'Check the fields entered',
            visualizza_a_schermo_intero: 'View full screen',
            visualizza_lavori_previsti: 'View planned jobs',
            visualizza_per: 'View by',
            visualizza_righe: 'View lines',
            visualizza_utenti_online: 'View users online',
            visualizzi_da: 'view from',
            zero_ore_lavorate_breve: '0 working hours',
        },
        fr: {
            a: 'à',
            a_tempo: 'à',
            ad_ore: "à l'heure",
            admin: 'administrateur',
            aggiorna: 'Mettre à jour',
            aggiorna_grafico: 'Mise à jour du graphique',
            aggiorna_tabella: 'Mettre à jour le tableau',
            aggiornamento_eseguito: 'Mise à jour réussie !',
            aggiungi: 'Ajouter',
            aggiungi_note: 'Ajouter des notes',
            allega_file: 'Joindre un fichier...',
            amministratore: 'Administrateur',
            amministratore_del_gruppo: 'administrateur de groupe',
            anno: 'Année',
            annulla: 'Annuler',
            annulla_modifica: 'Annuler Modifier',
            applica: 'Appliquer',
            archivia: 'Archiver',
            archiviazione_eseguita: 'Stockage effectué avec succès !',
            archivio_elimina_selezionati: 'Supprimer sélectionné',
            autenticazione_2FA: 'Authentification 2FA',
            avvia_timer: 'Minuterie de démarrage',
            avviso_date_con_date_disabilitate:
                "Si la plage de dates sélectionnée inclut des dates désactivées, le système générera autant d'associations que de plages de dates qui sont trouvées.",
            azioni: 'Actes',
            benvenuto_descrizione: "Chat d'entreprise à portée de main",
            benvenuto_titolo: 'flux',
            benvenuto_utente: 'Bienvenue',
            blocca_timer_per_disconnetterti: 'Verrouiller la minuterie pour déconnecter',
            calcola_data_fine: 'Calculer la date de fin estimée',
            calendario: 'Calendrier',
            cambia_immagine: "Changer d'image",
            cambia_password: 'Change password',
            cambia_tema: 'Changer de thème',
            cambio_lingua: 'Changement de langue en cours...',
            campo_obbligatorio: '(*) = Données obligatoires',
            campo_richiesto: 'champs requis',
            carica_file: 'Sélectionnez ou faites glisser un ou plusieurs fichiers à télécharger',
            caricamento_dati: 'Chargement des données en cours...',
            categoria: 'Catégorie',
            categorie: 'Catégories',
            categorie_utenti: "Catégories d'utilisateur",
            cerca: 'Recherche...',
            cerca_gif: 'Cherchez un GIF...',
            chiudi: 'Proche',
            clicca_per_aprire_messaggio_fissato: 'Cliquez pour ouvrir le message fixe',
            clicca_per_rimuovere_messaggio_fissato: 'Cliquez pour supprimer le message fixe',
            cliente: 'Client',
            codice: 'Code',
            codice_autenticazione: 'authentication code',
            codice_inviato: 'Code envoyé ! Vérifiez votre e-mail pour continuer.',
            codice_obbligatorio: 'Le code est obligatoire !',
            codice_prodotto: 'code de produit',
            codice_prodotto_breve: 'code de produit',
            codice_recupera_password_verificato:
                'code vérifié correctement, procédez à la saisie du nouveau mot de passe',
            codice_testo:
                "Entrez le code qui vous a été envoyé par e-mail avant l'expiration de l'heure",
            cognome: 'Nom de famille',
            cognome_utente: "Nom d'utilisateur",
            collaboratori_esterni: 'ressources externes',
            colore: 'Couleur',
            commessa: 'vendeur',
            commessa_aggiornata: 'Vendeuse mise à jour avec succès !',
            commessa_duplicata: 'Vendeuse dupliquée avec succès !',
            commessa_eliminata: 'Vendeuse éliminée avec succès !',
            commessa_ricevuta: 'Commande reçue',
            commessa_risorsa_aggiornata: 'Vendeuse mise à jour avec succès !',
            commesse_giornaliere: 'Commandes quotidiennes',
            commesse_importate: 'Commandes importées avec succès',
            completato: 'Terminé',
            concludi: 'Conclure',
            conclusa: 'achevé',
            concluso: 'achevé',
            conferma: 'Confirmation',
            conferma_archivia:
                'Voulez-vous vraiment stocker les données sélectionnées ? Cette opération sera réversible à partir de la section "Archive".',
            conferma_creazione_lavoro:
                'Un ou plusieurs utilisateurs ont la date de fin du travail après la date de fin estimée de la commande. Voulez-vous continuer ?',
            conferma_elimina:
                'Voulez-vous vraiment supprimer les données sélectionnées ? Cette opération ne sera pas réversible.',
            conferma_mandare_rapportino:
                'Confirmez-vous que vous souhaitez envoyer le rapport au client ?',
            configurazione_orari_giorni: 'Jours de configuration des horaires',
            copia_desc_beep: 'Copie Description Rapport',
            copia_descrizione_rapportino: 'Copier la description du rapport pour Bee.p',
            copia_orario_per_giorni_seguenti: 'Copie pour les jours suivants',
            costo_finale: 'coût final',
            crea: 'Créer',
            creatoIl: 'créé le',
            creazione_eseguita: 'Création réussie !',
            da_pianificare: 'planifier',
            da_tempo: 'de',
            data: 'Date',
            data_fine: 'date de fin',
            data_fine_maggiore_data_inizio:
                'La date de fin doit être supérieure à la date de début',
            data_fine_stimata: 'Date de fin estimée',
            data_inizio: 'date de début',
            data_intervento: "Date d'intervention",
            data_nascita: 'Date de naissance',
            data_non_valida: "La date sélectionnée n'est pas valide",
            data_popover_mancante: 'Date finale manquante',
            data_ultimo_login: 'Dernière connexion',
            date: 'Rendez-vous',
            date_utente_non_disponibile: "Dates où l'utilisateur n'est pas disponible",
            dati_non_disponibili: 'Données non disponibles',
            dati_personali: 'Données personnelles',
            denominazione: 'Prénom',
            descrizione: 'Description',
            descrizione_fase: 'Description de la phase',
            descrizione_prodotto: 'Description du produit',
            deseleziona_tutti: 'Décochez tout',
            destinatario: 'Bénéficiaire',
            dettagli_base: 'Détails de base',
            dettagli_cliente: 'Détails du client',
            dettagli_fase: 'Détails de la phase',
            dettagli_lavoro: 'Détails du poste',
            dettagli_prodotto: 'Détails du produit',
            dettagli_utente: "Détails d'utilisateur",
            di: 'de',
            dimensione_file_non_valida: 'Le fichier dépasse la taille maximale autorisée, 10 Mo',
            dimensione_massima_file: 'Le fichier dépasse la taille maximale autorisée, 5 Mo',
            dipendente_cliente: 'Employé client',
            disponibile: 'Disponible',
            documento: 'Document',
            duplica_commessa: 'commande en double',
            durata: 'Durée',
            durata_attuale: 'heures ATT.',
            durata_giornata_lavorativa: 'Durée du jour ouvrable',
            durata_prevista: 'heures avant',
            elementi: 'éléments',
            elimina: 'Supprimer',
            elimina_commessa: 'Supprimer la vendeuse',
            eliminazione_eseguita: 'Élimination réussie !',
            email: 'email',
            emailResetPassInviata:
                "E-mail pour la réinitialisation du mot de passe envoyé à l'utilisateur spécifié.",
            email_cliente: 'Courriel client',
            email_invio_rapportino: "e-mail que j'envoie",
            error_effettua_login: 'Connectez-vous pour continuer',
            error_sottotitolo_401:
                "Désolé, mais vous n'avez pas les autorisations nécessaires pour terminer l'opération. Veuillez réessayer ultérieurement et si l'erreur persiste, contactez notre équipe technique pour fournir des détails sur l'opération. Merci pour votre compréhension et votre patience.",
            error_sottotitolo_404:
                "Nous nous excusons, mais la page que vous recherchez n'est pas disponible ou a été déplacée. Vérifiez l'URL et assurez-vous qu'elle est correcte. Si le problème persiste, cela peut être dû à un lien obsolète ou à une ressource supprimée.",
            error_sottotitolo_generale:
                "Désolé, une erreur inattendue s'est produite pendant l'opération. Veuillez réessayer ultérieurement et si l'erreur persiste, contactez notre équipe technique pour fournir des détails sur l'opération. Merci pour votre compréhension et votre patience.",
            error_titolo_401: 'non autorisé',
            error_titolo_404: 'Page introuvable',
            error_titolo_generale: 'Erreur rencontrée',
            error_torna_pagina_iniziale: "Retour à la page d'accueil",
            errore: 'Erreur',
            errore_copia: 'Erreur de copie dans le presse-papiers !',
            errore_generazione_qr: 'Erreur de génération QR !',
            esporta: 'Exporter',
            fase: 'Phase',
            favorite_page_pagina_aggiunta: 'Page ajoutée aux favoris',
            favorite_page_pagina_rimossa: 'Page supprimée des favoris',
            ferma_timer: "Minuterie d'arrêt",
            file_caricato: 'Fichier téléchargé',
            file_e_documenti: 'Fichiers et documents',
            file_media: 'Fichier / Média',
            file_non_supportato: 'Fichier non pris en charge',
            file_troppo_grande: 'Fichier trop gros',
            fino_a: 'Avant',
            fornitura: 'La fourniture',
            foto: 'Photo',
            genera_password: 'Générer des mots de passe',
            genera_qr: 'Générer un QR',
            gestione_orari: 'Gestion du temps',
            grafico: 'Graphique',
            id: 'Ça',
            immagine_gruppo: 'image de groupe',
            immagine_profilo: 'Image de profil',
            immagine_profilo_aggiornata: 'Photo de profil mise à jour avec succès !',
            importa: 'Importer',
            in_corso: 'En progression',
            inattivita_descrizione_1: 'Une inactivité prolongée a été constatée.',
            inattivita_descrizione_2: 'Pour des raisons de sécurité, vous avez été déconnecté.',
            inattivita_titolo: 'Inactivité détectée !',
            indirizzo_ip: 'adresse IP',
            indirizzo_luogo_intervento: "adresse du lieu d'intervention",
            info_aggiuntive: 'Information additionnelle',
            informazione: 'Information',
            informazioni_breve: 'INFO',
            informazioni_generali: 'informations générales',
            inserire_ore_lavorate_effettive: 'Entrez les heures réelles travaillées',
            inserire_ore_lavorate_minimo_0_5: 'Entrez les heures travaillées (0,5 minimum)',
            inserire_relazione_intervento: "Saisir le rapport de l'intervention",
            inserisci_mail_valida: 'Entrez un e-mail valide',
            installa_pwa: 'Installer l’application',
            invia_credenziali: "Envoyer des informations d'identification par e-mail",
            invia_file: 'Envoyer des fichiers',
            invia_rapportino: 'Envoyer un rapport',
            inviata_amministrazione: "envoyé à l'administration",
            inviata_cliente: 'envoyé au client',
            km_percorsi: 'km parcourus',
            legenda: 'légende',
            legenda_categorie_commesse: 'Légende Catégories engagées',
            legenda_tag: 'Balises de légende',
            lista: 'Liste',
            livello: 'Niveau',
            login_aggiorna_accedi: 'Mettre à jour et se connecter',
            login_attendi: 'Attendez ...',
            login_attendi_riprova: 'Attendez de réessayer !',
            login_benvenuto: 'Bienvenue!',
            login_campi_obbligatori:
                "Entrez le nom d'utilisateur et le mot de passe pour continuer",
            login_campo_non_sicuro: 'Champ dangereux !',
            login_codice_scaduto: 'Code expiré ! Réessayez pour continuer',
            login_conferma_password: 'Confirm password',
            login_controlla_mail: 'Vérifiez les e-mails pour continuer',
            login_effetta_accesso: 'se connecter',
            login_email_reset_pass_inviata:
                "E-mail pour la réinitialisation du mot de passe envoyé à l'utilisateur spécifié.",
            login_livello_sicurezza_password: 'Niveau de sécurité des mots de passe',
            login_password: 'Mot de passe',
            login_password_dimenticata: 'Mot de passe oublié ?',
            login_password_non_uguali: 'Les mots de passe ne correspondent pas',
            login_reset_password: 'Réinitialiser le mot de passe',
            login_submit_text: 'se connecter',
            login_suggerimenti_password: 'Password tips',
            login_suggerimenti_password_1:
                'Le mot de passe doit contenir au moins une lettre minuscule',
            login_suggerimenti_password_2:
                'Le mot de passe doit contenir au moins une lettre majuscule',
            login_suggerimenti_password_3: 'Le mot de passe doit contenir au moins un numéro',
            login_suggerimenti_password_4:
                'Le mot de passe doit contenir au moins un caractère spécial',
            login_suggerimenti_password_5: 'Le mot de passe doit contenir au moins 8 caractères',
            login_timeout_codice: 'Code de vérification expiré',
            login_troppe_richieste: 'Vous avez fait trop de demandes !',
            login_usa_password: 'Utilisez votre mot de passe',
            login_username: "Nom de l'utilisateur",
            login_username_reset_password:
                'Entrez le nom d\'utilisateur pour lequel vous souhaitez demander la réinitialisation du mot de passe dans le champ "nom d\'utilisateur".',
            login_utente_non_trovato: "Impossible de trouver l'utilisateur inséré !",
            logout_conferma_disconnessione: 'Confirmation',
            logout_disconnessione: 'Coupure',
            logout_disconnetti: 'Couper',
            logout_messaggio_disconnessione: 'Voulez-vous vraiment vous déconnecter ?',
            luogo_intervento: "Lieu d'intervention",
            media_caricati: 'Média chargé',
            membri: 'Adhésion',
            menu_gestori: 'administrateurs',
            menu_gestori_tooltip: 'Données personnelles - Administrateurs',
            menu_anagrafiche: 'données personnelles',
            menu_categorie_commesse: 'Catégories engagées',
            menu_categorie_commesse_tooltip: 'Données personnelles - Catégories validées',
            menu_categorie_utenti: 'Catégories de ressources',
            menu_categorie_utenti_tooltip: 'Données - Catégories de ressources',
            menu_commesse: 'engagé',
            menu_commesse_occupazione: 'Occupation',
            menu_commesse_occupazione_tooltip: 'Commandes - Occupation',
            menu_commesse_pianificazione: 'Planification',
            menu_commesse_pianificazione_tooltip: 'Commandes - Planification',
            menu_commesse_resoconto: 'Rapport',
            menu_commesse_resoconto_apprendisti: 'Rapport de ressources',
            menu_commesse_resoconto_apprendisti_tooltip: 'Commandes - Rapport de ressources',
            menu_commesse_resoconto_tooltip: 'Commandes - Rapport',
            menu_dashboard: 'Tableaux de bord',
            menu_gruppi: 'Groupes de discussion',
            menu_gruppi_tooltip: 'Données de base - Groupes de discussion',
            menu_impostazioni: 'Réglages',
            menu_log: 'bûches',
            menu_log_messaggi: 'Journal des messages',
            menu_log_messaggi_tooltip: 'Journal - Messages',
            menu_log_tecnici: 'Journaux techniques',
            menu_log_tecnici_tooltip: 'Journal - Techniciens',
            menu_occupazione: 'Occupation',
            menu_priorita_commesse: 'Commandes prioritaires',
            menu_priorita_commesse_tooltip: 'Données personnelles - Commandes prioritaires',
            menu_apprendisti: 'Ressources',
            menu_apprendisti_tooltip: 'Données personnelles - Ressources',
            menu_tag_commesse: 'Tags commandes',
            menu_tag_commesse_tooltip: 'Données personnelles - Tags Commandes',
            menu_utilita: 'Utilitaire',
            menu_utilita_archivio: 'Archiver',
            menu_utilita_archivio_tooltip: 'Utilitaire - Archive',
            menu_utilita_calendario_eventi: 'Calendrier des événements',
            menu_utilita_calendario_eventi_tooltip: 'Utilitaire - Calendrier des événements',
            menu_utilita_chat: 'Bavarder',
            menu_utilita_chat_tooltip: 'Utilitaire - Chat',
            mese: 'Mois',
            messaggi: 'Messages',
            messaggi_da_leggere: 'Messages à lire',
            messaggio_fissato: 'Message épinglé',
            messaggi_per_giorno: 'Messages par jour',
            messaggi_solo_gestori: 'Seuls les administrateurs de groupe peuvent écrire',
            messaggi_solo_gestori_breve: 'Seuls les administrateurs peuvent écrire',
            messaggio: 'Message',
            messaggio_completo: 'Message complet',
            messaggio_conclusione_commessa: 'Signaler la commande comme conclue ?',
            messaggio_conferma_eliminazione_lavoro: 'Élimination réussie',
            messaggio_conferma_eliminazione_selezionati: 'Données supprimées avec succès !',
            messaggio_conferma_ripristino_selezionati: 'Données restaurées avec succès !',
            messaggio_duplicazione: 'dupliquer la commande ?',
            messaggio_eliminato: 'Message supprimé',
            messaggio_eliminazione: 'éliminer la commande ?',
            messaggio_eliminazione_lavoro: 'Voulez-vous vraiment supprimer le travail suivant ?',
            messaggio_eliminazione_selezionati:
                'Voulez-vous vraiment supprimer les données sélectionnées ?',
            messaggio_manda_rapportino: 'Envoie le rapport au client',
            messaggio_ripristina_selezionati:
                'Voulez-vous vraiment restaurer les données sélectionnées ?',
            mezza_giornata: 'Demi journée',
            mittente: 'Expéditeur',
            modifica: 'Modification',
            modifica_lavori: 'Modifier les travaux',
            modificato: 'Modifié',
            mostra: '(Afficher le message complet)',
            mostra_dashboard_commesse: 'Afficher les tableaux de bord des commandes',
            mostra_dettagli: 'Afficher les détails',
            mostra_informazioni: 'Afficher des informations supplémentaires',
            mostra_occupazione: 'montrer la profession',
            mostra_ore: "Afficher le nombre d'heures",
            mostrando: 'projection',
            n_fase: 'Numéro de phase',
            nessun_cliente_selezionato: 'Aucun client sélectionné',
            nessun_dato_archiviato: "Aucune donnée n'est marquée comme archivée",
            nessun_dato_disponibile: 'Aucune donnée disponible',
            nessun_messaggio_da_leggere: "Vous n'avez aucun message à lire. Bravo!",
            nessun_parametro: 'Aucun paramètre',
            nessuna_chat_selezionata: 'Pas de discussion sélectionnée',
            nessuna_email_cliente: "Aucun e-mail n'est présent pour le client sélectionné",
            no: 'Non',
            no_concluso: 'pas conclu',
            no_messaggi_nuovi: "Aucun nouveau message n'a été envoyé",
            nome: 'Prénom',
            nome_utente: "Nom de l'utilisateur",
            nominativo: 'Nominatif',
            nominativo_cliente: 'Nom du client',
            nominativo_dipendente: "Nom de l'employé du client",
            non_disponibile: 'Indisponible',
            non_programmato: 'Non programmé',
            note: 'notes',
            note_amministrative: 'Notes administratives',
            note_amministrative_breve: "Notes d'administrateur.",
            note_intervento: 'Remarques Intervention',
            numero: 'Numéro',
            numero_commessa: 'Nom engagé',
            numero_documento: 'Document non',
            nuovo_messaggio: 'Vous avez un nouveau message',
            occupazione: 'Occupation',
            offline: 'Hors ligne',
            oggi: "Aujourd'hui",
            online: 'en ligne',
            online_ora: 'En ligne maintenant',
            oppure: 'ou alors',
            opzioni_disponibili: 'Options disponibles',
            ora_fine: 'temps de fin',
            ora_fine_obbligatoria: 'Heure de fin obligatoire',
            ora_fine_turno: 'Heure de fin de quart de travail',
            ora_inizio: 'Maintenant je commence',
            ora_inizio_obbligatoria: 'Démarrage désormais obligatoire',
            ora_inizio_turno: 'Tournez Démarrer maintenant',
            ore_effettive: 'Heures réelles',
            ore_lavorate: 'heures travaillées',
            ore_lavorate_breve: 'Heures de travail',
            ore_lavorate_breve_header: 'Heures de travail',
            ore_lavorate_effettive: 'Heures travaillées réelles',
            ore_lavorate_effettive_breve_header: 'heures eff.',
            ore_previste: 'Heures prévues',
            ore_programmate: 'Heures prévues',
            ore_toggle_popover_mancanti: 'Temps manquant',
            ore_viaggio: 'Heures de déplacement',
            panoramica_sistema: 'System overview',
            parametri: 'Paramètres',
            parametri_prodotto: 'Paramètres du produit',
            password: 'Mot de passe',
            password_aggiornata: 'Password successfully updated!',
            password_cambiata: 'Mot de passe changé avec succès !',
            password_gia_usata:
                'Le mot de passe a déjà été utilisé auparavant ! Entrez-en un autre pour continuer.',
            percentuale_completamento: 'Le progrès',
            personali: 'personnel',
            pianifica: 'Plan',
            pianificata: 'prévu',
            pianificato: 'prévu',
            pianificazione: 'Planification',
            preferiti: 'Favoris',
            priorita: 'Priorité',
            priorita_lavoro: 'Priorité au travail',
            privacy_policy:
                "<h1> Informations pour le traitement des données </h1> <p> Cette page décrit les méthodes de gestion du site en référence au traitement des données personnelles des utilisateurs qui le consultent, ainsi que les méthodes et objectifs de traitement des données personnelles. </p> <p> Il s'agit d'une information fournie également en vertu de l'article 13-14 Reg. 2016/679 à ceux qui interagissent avec des services Web accessibles électroniquement à partir de l'adresse. </p> <p> Les informations sont fournies uniquement pour le site en question et non pour d'autres sites Web, si nécessaire, disponibles via nos liens, dont il n'est pas responsable de quelque manière que ce soit. </p> <p> en qualité de responsable du traitement de vos données personnelles, conformément à et aux fins du règlement européen. 2016/679 - GDPR vous informe que la législation susmentionnée prévoit la protection des parties intéressées en ce qui concerne le traitement des données personnelles et que ce traitement sera basé sur les principes d'exactitude, de légalité, de transparence et de protection de votre confidentialité et de vos droits. </p> <p>Vos données personnelles seront traitées conformément aux dispositions législatives de la législation susmentionnée et aux obligations de confidentialité qui y sont prévues. Il et les procédures logicielles utilisées pour exploiter ce site Web acquièrent, lors de leur fonctionnement normal, certaines données personnelles dont la transmission est implicite dans l'utilisation des protocoles de communication Internet. Il s'agit d'informations qui ne sont pas collectées pour être associées à des parties intéressées identifiées, mais qui, par leur nature même, pourraient, par le traitement et l'association avec des données détenues par des tiers, permettre l'identification des utilisateurs. Cette catégorie de données comprend des adresses IP ou des noms de domaine d'ordinateurs utilisés par les utilisateurs se connectant au site, les adresses en URI (Uniform Resource Identifier) Notation des ressources demandées, le moment de la demande, la méthode utilisée pour soumettre la demande au serveur, la taille du fichier obtenue en réponse, le code numérique indiquant le État de la réponse donnée par le serveur (réussie, erreur, etc.) et d'autres paramètres relatifs au système d'exploitation et à l'environnement informatique de l'utilisateur. Ces données sont utilisées dans le seul but d'obtenir des informations statistiques anonymes sur l'utilisation du site et de vérifier son bon fonctionnement et sont supprimées immédiatement après le traitement. Les données pourraient être utilisées pour déterminer la responsabilité en cas de délits informatiques hypothétiques contre le site. </p> <h3> Données fournies volontairement par l'utilisateur </h3> <p> L'envoi facultatif, explicite et volontaire des e-mails aux adresses indiquées sur ce site, ainsi que la compilation des formulaires d'envoi de demandes spécifiques impliquent la prochaine acquisition de la Adresse de l'expéditeur, nécessaire pour répondre aux demandes, ainsi que toutes autres données personnelles incluses dans la lettre ou le formulaire. <br /> Informations récapitulatives Les spécifications sont signalées ou affichées sur les pages du site préparées pour des services particuliers sur demande. </p> <h2>Conséquences du refus de fournir des données </h2> <p> En dehors de ce qui est spécifié pour les données de navigation, l'utilisateur est libre de fournir les données personnelles indiquées dans les formulaires de demande, l'enregistrement sur les listes de diffusion ou, en tout cas, indiqués dans les contacts à la demande d'envoi informations, matériels techniques ou commerciaux ou autres communications. Ne pas les fournir peut empêcher l'obtention de ce qui est demandé. </p> <h2>Méthode de traitement </h2> <p> Les données sont principalement traitées avec des outils électroniques et informatiques et stockées à la fois sur support informatique et sur papier et sur tout autre type de support approprié, conformément aux procédures prévues à l'art. 6, 32 du RGPD et par l'adoption des mesures de sécurité appropriées envisagées. Pour éviter la perte de données, une utilisation illégale ou incorrecte et un accès non autorisé. Nous vous informons que, pour fournir un service complet, notre portail peut contenir des liens vers d'autres sites Web, non gérés par nous. Nous ne sommes pas responsables des erreurs, contenus, cookies, publications de contenus moraux illicites, publicités, bannières ou fichiers qui ne respectent pas les réglementations en vigueur et le respect de la législation en matière de confidentialité par les sites auxquels nous nous référons. Pour améliorer le service offert, un rapport immédiat de dysfonctionnements, d'abus ou de suggestions à l'adresse e-mail est le bienvenu. Vos données ne seront traitées que par du personnel expressément autorisé par le responsable du traitement des données. </p> <h2>Finité du traitement </h2> <p> Le traitement des données sera effectué à : <br /> - donner la possibilité d'accéder aux sections publiques et/ou confidentielles du site ; <br /> - Mettre en œuvre l'activation et la maintenance de tous les services en ligne souscrits ; <br /> - Exécuter les obligations en vertu des lois ou des règlements ; <br /> - La protection du propriétaire en cour ; <br /> - Envoyer du matériel d'information commercial ou promotionnel <br /> - Permettre un suivi constant de l'efficacité du service proposé. </p> <h2>Les sujets auxquels les données personnelles peuvent être communiquées </h2> <p> Les données personnelles relatives au traitement en question peuvent également être communiquées à des sujets qui ont le droit d'accéder à vos données personnelles par la loi ou les réglementations secondaires et/ou communautaires. En outre, certaines données peuvent être communiquées et diffusées aux opérateurs Internet pour la gestion de leurs domaines. La diffusion des données collectées n'est pas prévue. </p> <h2>Période de conservation des données </h2> <p> Nous soulignons que, conformément aux principes de légalité, de limitation des objectifs et de minimisation des données, conformément à l'art. 5 du RGPD, la durée de conservation de vos données personnelles est de 15 ans. À l'expiration de la période de conservation susmentionnée, les données personnelles seront automatiquement supprimées. </p> <h2>Droits des parties intéressées</h2> <p>UE 2016/679 : art. 15, 16, 17, 18, 19, 20, 21, 22 - Droits de la partie intéressée </p> <p> 1. L'intéressé a le droit d'obtenir la confirmation de l'existence ou non de données personnelles le concernant, même si ce n'est pas encore le cas enregistrés et leur communication sous une forme intelligible. </p> <p> 2. L'intéressé a le droit d'obtenir l'indication : <br /> A. L'origine des données personnelles ; <br /> B. Les objectifs et les méthodes de traitement ; <br /> C. La logique appliquée dans le cas d'un traitement effectué à l'aide d'outils électroniques ; <br /> D. Les détails d'identification du propriétaire, des gestionnaires et du représentant désigné conformément à l'article 5, paragraphe 2; <br /> et. des sujets ou des catégories de sujets auxquels les données personnelles peuvent être communiquées ou qui peuvent en prendre connaissance en tant que représentant désigné sur le territoire de l'État, en tant que gestionnaires ou responsables. </p> <p> 3. La partie intéressée a le droit d'obtenir : <br /> a. mise à jour, rectification ou, lorsque cela est intéressé, l'intégration des données ; <br /> B. L'annulation, la transformation en forme anonyme ou le blocage des données traitées en violation de la loi, y compris celles dont la conservation n'est pas nécessaire en fonction des finalités pour lesquelles les données ont été collectées ou traitées ultérieurement ; <br /> C. L'attestation que les opérations mentionnées dans les lettres a) et b) ont été portées à l'attention, également en ce qui concerne leur contenu, de ceux auxquels les données ont été communiquées ou diffusées, sauf dans le cas où cet accomplissement s'avère impossible ou implique l'utilisation de moyens <br /> D. manifestement disproportionné par rapport au droit protégé ; <br /> et. Portabilité des données. </p> <p> 4. La partie intéressée a le droit de s'opposer, en tout ou en partie : <br /> a. pour des raisons légitimes au traitement des données personnelles le concernant, même si cela est pertinent à l'objet de la collecte ; <br /> B. Au traitement des données personnelles le concernant dans le but d'envoyer du matériel publicitaire ou de vente directe ou de mener des recherches de <br /> c. Communication commerciale ou commerciale </p> <p> L'utilisateur a le droit d'obtenir l'annulation du responsable du traitement des données (droit à l'oubli), la limitation, la mise à jour, la rectification, la portabilité, l'opposition au traitement des données personnelles vous concernant, ainsi qu'en général, peuvent exercer tous les droits prévus par l'art. 15, 16, 17, 18, 19, 20, 21, 22 du RGPD. </p> <p>Pour exercer les droits énumérés ci-dessus, l'intéressé doit faire une demande écrite par e-mail.</p> <p></p> <h2>Cookies</h2> <p> Les cookies désignent un élément textuel qui est inséré dans le disque dur d'un ordinateur ou d'un autre appareil à partir de Le fournisseur du service en ligne aux visiteurs du site Web. Les cookies peuvent collecter des informations sur les habitudes des visiteurs concernant l'utilisation du site Web susmentionné, l'enregistrement des activités de leur ordinateur ou d'un autre appareil concernant le site susmentionné, par exemple lorsqu'il s'agit d'effectuer des achats. </p> <h3> Les cookies peuvent être : </h3> <h3> Cookies propriétaires (également appelés propriétaires) </h3> <p> Les cookies propriétaires sont des cookies qui sont enregistrés directement sur votre ordinateur ou un autre appareil. Ils peuvent inclure des cookies tels que des cookies de session et des cookies persistants (décrits ci-dessous).</p> <p>Les cookies propriétaires peuvent être utilisés pour suivre les mouvements effectués par l'ordinateur du visiteur ou un autre appareil en consultant le site, à des fins d'analyse.</p> <h3>Tiers-tierces parties </h3> <p> Aucun cookies tiers n'est stocké </p> <h3> Cookies de session </h3> <p> La durée entre le moment où le navigateur Internet s'ouvre et le moment où il est fermé est appelé une session de navigation. Les cookies de session sont des cookies stockés sur l'ordinateur du visiteur ou sur un autre appareil lors d'une session de navigation, mais qui expirent et sont normalement supprimés à la fin d'une session de navigation. </p> <h3>Cookies persistants</h3> <p> Les cookies persistants sont des cookies stockés sur l'ordinateur du visiteur ou sur un autre appareil lors d'une session de navigation, mais qui restent sur l'ordinateur ou sur un autre appareil après la fin de la session de navigation susmentionnée (par exemple, enregistrement du mot de passe). Les cookies persistants permettent aux sites de reconnaître l'ordinateur du visiteur ou un autre appareil lorsqu'il est utilisé pour accéder à nouveau à l'un de nos sites, après la fin d'une session de navigation et au début d'une nouvelle session de navigation, essentiellement pour aider le visiteur à se reconnecter rapidement à notre site. </p> <p> Ce site, pour des raisons strictement techniques, utilise les types de cookies suivants : <br /> - Cookies techniques et de session, par exemple pour éviter que - le cas échéant - l'utilisateur entre le mot de passe plusieurs fois pour accéder aux sections réservées du site, ou pour stocker la navigation préférée. langue, ou pour stocker certaines caractéristiques techniques du navigateur utilisé pour la navigation (y compris l'acceptation des cookies). </p> <p>Il est possible de désactiver l'utilisation de cookies, mais en choisissant une telle option, il est probable que le site présente des dysfonctionnements, plus ou moins évidents selon la section du site que vous souhaitez visiter. </p> <p> Pour désactiver les cookies, en fonction du navigateur utilisé, nous pouvons suggérer quelques guides (valide au moment où ce document a été écrit).</p> <h3>Chrome</h3> <p>1. Exécutez le navigateur Chrome</p> <p>2. Cliquez sur le menu dans la barre d'outils du navigateur à côté de la fenêtre de saisie d'URL pour la navigation </p> <p> 3. Sélectionnez Paramètres</p> <p>4. Cliquez sur Afficher les paramètres avancés</p> <p>5. dans le & ldquo ; Confidentialité et rdquo ; section; Cliquez sur le bouton &laquo;Paramètres de contenu&ldquo;</p> <p>6. dans le & ldquo ; Cookie & rdquo ; Section Vous pouvez modifier les paramètres suivants relatifs aux cookies :</p> <ul> <li>Autoriser l'enregistrement des données localement</li> <li>Modifier les données locales uniquement jusqu'à ce que le navigateur soit fermé</li> <li>Toutes les sites pour configurer les cookies</li> <li>Bloquer les cookies tiers et Données de site</li> <li>Gestion des exceptions pour certains sites</li> <li>Suppression d'un ou de tous les cookies</li> </ul> <p> Pour plus d'informations, visitez <a href=\"https://support.google.com/accounts/answer/61416?hl=it\" target=\"_blank\"> page dédiée </a>. </p> <h3>Mozilla Firefox</h3> <p>1. Exécutez le navigateur Mozilla Firefox</p> <p>2. Cliquez sur le menu de la barre d'outils du navigateur à côté de la fenêtre de saisie d'URL pour la navigation </p> <p> 3. Sélectionnez Options</p> <p>4. Sélectionnez le panneau de confidentialité</p> <p>5. Cliquez sur Afficher les paramètres avancés</p> <p>6. dans le & ldquo ; Confidentialité et rdquo ; section; Cliquez sur le bouton <p>7 Paramètres de contenu&ldquo;</p>. dans le & ldquo ; Suivi et rdquo ; section; Vous pouvez modifier les paramètres suivants liés aux cookies :</p> <ul> <li>Demandez aux sites de ne pas suivre de suivi</li> <li>Communiquer les sites à suivre</li> <li>Ne communiquez aucune préférence de suivi de données personnelles</li> </ul> <p>8. du & ldquo ; Chronologie & rdquo ; section; Vous pouvez : </p> <ul> <li> en activant &ldquo;utiliser les paramètres personnalisés&rdquo; Sélectionnez pour accepter les cookies tiers (toujours, depuis les sites les plus visités ou jamais) et pour les conserver pendant une période spécifique (jusqu'à leur expiration, lorsque Firefox est fermé ou à chaque fois) </li> <li>Supprimer les cookies individuels stockés</li> </ul> <p> Pour plus d'informations, visitez <a href=\"https://support.mozilla.org/it/kb/activate%20e%20disable%20i%20cookie\" cible = \"_blank\"> page dédiée </a>. </p> <h3>Explorateur Internet</h3> <p>1. Exécutez Internet Explorer</p> <p>2 navigateur. Cliquez sur le bouton Outils et choisissez Options Internet</p> <p>3. Cliquez sur l'onglet Confidentialité et dans la section Paramètres, modifiez le curseur en fonction de l'action souhaitée pour les cookies : </p> <ul> <li> bloquer tous les cookies </li> <li> Autoriser tous les cookies </li> <li> Sélection de sites pour obtenir les cookies : déplacer le curseur vers une position intermédiaire Afin de ne pas bloquer ou autoriser tous les cookies, puis appuyez sur les sites, dans la zone Adresse du site Web, insérez un site Web, puis appuyez sur Bloquer ou autoriser </li> </ul> <p> Pour plus d'informations, consultez le <a href=\"https://support.microsoft.com/it-it/products/windows?os=windows-10\" target=\"_blank\"> page dédiée </a>. </p> <h3>Safari 6/7 </h3> <p>1. Exécutez le navigateur Safari</p> <p>2. Cliquez sur Safari, sélectionnez Préférences et appuyez sur la confidentialité</p> <p>3. Dans la section Bloquer les cookies, spécifiez comment Safari doit accepter les cookies des sites Web.</p> <p>4. Pour voir quels sites ont stocké les cookies, cliquez sur Détails </p> <p> Pour plus d'informations, visitez <a href=\"https://support.apple.com/kb/ph17191?locale=fr_US&amp;viewlocale=en_it\" target=\"_blank\"> page dédiée </a>. </p> <h3> Safari iOS (appareils mobiles) </h3> <p>1. Exécutez le navigateur Safari iOS</p> <p>2. Appuyez sur Paramètres, puis Safari </p> <p>3. Appuyez sur Bloquer les cookies et choisissez parmi les différentes options : & ldquo ; Jamais & rdquo ;, & ldquo ; tiers et annonceurs & rdquo; ou & ldquo ; Toujours & rdquo; </p> <p> 4. Pour supprimer tous les cookies stockés par Safari, appuyez sur Paramètres, puis sur Safari et enfin sur Supprimer les cookies et les données</p> <p> pour plus d'informations, visitez <a href=\"https://support.apple.com/it-it/ht201265\" target=\"_blank\"> page dédiée </a>. </p> <h3>travail</h3> <p>1. Exécutez le navigateur Opera</p> <p>2. Cliquez sur les préférences puis sur Avancés et enfin sur les cookies </p> <p> 3. Sélectionnez l'une des options suivantes :</p> <ul> <li>Acceptez tous les cookies</li> <li>Acceptez les cookies du site que vous visitez : les cookies tiers qui sont envoyés à partir d'un domaine autre que Celui que vous visitez sera rejeté</li> <li>Ne pas accepter jamais les cookies : tous les cookies ne seront jamais enregistrés </li> </ul> <p> Pour plus d'informations, consultez le <a href=\"https://www.opera.com/help/tutorials/security/privacy/\"target=\"_blank\">page dédiée </a>. </p> <p> Si le programme que vous utilisez pour naviguer sur les sites Web ne fait pas partie de ceux mentionnés ci-dessus, nous vous suggérons d'utiliser un moteur de recherche en ligne (Google, Yahoo, Bing & Hellip) pour comprendre comment désactiver les cookies dans ce navigateur spécifique. </p>",
            prodotti: 'Production',
            prodotti_relativi_ordine: 'Produits liés à la commande',
            prodotti_utilizzati: 'Produits utilisés',
            prodotto: 'Produit',
            profilo_aggiornato: 'Profil mis à jour avec succès !',
            profilo_personale: 'Profil personnel',
            pulisci_date:
                "Nettoyez les heures de début et de fin pour pouvoir modifier manuellement le nombre total d'heures",
            quantita: 'Montant',
            quantita_prodotto: 'quantité de produit',
            raggruppa_per: 'grouper par',
            rapportino_inviato: 'Rapport envoyé avec succès !',
            rapportino_ricevuto: 'Rapport reçu',
            relazione_intervento: "Rapport d'intervention",
            report: 'Rapports',
            resoconto: 'Rapport',
            resoconto_commesse: 'Rapport de commande',
            righe_effettive: 'Lignes réelles',
            rimuovi: 'Supprimer',
            riprendi_timer: 'Minuterie de reprise',
            ripristina: 'Restaurer',
            risorsa: 'Ressource',
            apprendisti: 'Ressources',
            rispondi_a: 'Répondre à',
            risposta_a: 'Réponds à',
            salva: 'Salve',
            scarica: 'Décharge',
            scorciatoia_ctrl_b: 'Ouvrir/Fermer : Ctrl+B',
            scrivi_messaggio: 'Rédigez votre message...',
            segnala_come_concluso: "Rapport tel qu'il est conclu",
            seleziona: 'Sélectionner',
            seleziona_filtro: 'Sélectionnez Filtre',
            seleziona_foto: 'Sélectionnez des photos',
            seleziona_mese: 'Choisissez le mois',
            seleziona_tutti: 'Sélectionner tout',
            seleziona_utente: "Sélectionnez l'utilisateur",
            selezionare_cliente:
                'Sélectionnez le client pour lequel vous souhaitez créer le rapport',
            selezionare_data_intervento: "Sélectionnez la date de l'intervention",
            selezionare_email_invio_rapportino: "Sélectionnez l'e-mail auquel envoyer le rapport",
            selezionare_luogo_intervento: "Sélectionnez le lieu d'intervention",
            send_rapportino_cliente: 'Signaler le client avec succès envoyé',
            sequenziale: 'séquentiel',
            settimana: 'Semaine',
            settimana_attuale: 'semaine en cours',
            si: 'Une',
            software_inedito_m2sistemi: 'Logiciel publié par M2 Sistemi S.r.l.',
            sta_scrivendo: 'écrit',
            standard: 'Standard',
            stato: 'État',
            stato_commessa_aggiornato: 'Commande mise à jour avec succès !',
            stato_lavoro: 'Statut Job',
            su: 'sur',
            su_cosa_hai_lavorato: 'Sur quoi avez-vous travaillé ?',
            successo: 'Succès',
            tags: 'étiquettes',
            telefono: 'Téléphone fixe',
            tempo_rimanente: 'Temps restant',
            termina_modifica: "Terminez d'abord le changement actuel !",
            testo_copiato: 'Texte copié dans le presse-papiers',
            testo_notifica: 'Texte de notification',
            tipo: 'Type',
            tipologia_destinatario: 'recipient type',
            tipologia_file_non_valida: "Le type de fichier n'est pas pris en charge",
            tipologia_turno: 'Type de ronde',
            titolo: 'Titre',
            titolo_cambio_password: 'Change password',
            torna_indietro: 'revenir',
            totale_ore: 'heures totales',
            totale_ore_turno: 'Total des heures de travail',
            trasferta: 'Transfert',
            tu: 'Vous',
            tutti_i_campi_devono_essere_compilati:
                'Tous les champs obligatoires doivent être remplis',
            url: 'URL',
            username: "Nom de l'utilisateur",
            username_destinatario: "Nom d'utilisateur du destinataire",
            username_esistente: "Nom d'utilisateur déjà existant",
            username_in_uso: "Nom d'utilisateur déjà utilisé",
            username_mittente: "Nom d'utilisateur de l'expéditeur",
            utente: 'Utilisateur',
            utenti: 'utilisateurs',
            utenti_con_piu_messaggi: 'Utilisateurs avec plusieurs messages',
            utenti_online: 'utilisateurs en ligne',
            utenti_totali: 'Total des utilisateurs',
            vai_a_gestori: 'Accédez aux administrateurs',
            vai_a_gruppi: 'Accédez aux données du groupe',
            vai_a_apprendisti: 'Accédez aux ressources',
            verifica_campi: 'Vérifiez les champs entrés',
            visualizza_a_schermo_intero: 'Voir le plein écran',
            visualizza_lavori_previsti: "Voir les offres d'emploi",
            visualizza_per: 'Voir par',
            visualizza_righe: 'Voir les lignes',
            visualizza_utenti_online: 'Afficher les utilisateurs en ligne',
            visualizzi_da: 'Voir de',
            zero_ore_lavorate_breve: '0 heures de travail',
        },
    },
}));
